var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetpasswordHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 676.144,
    height: 439.848,
    viewBox: "0 0 676.144 439.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resetpasswordHero",
    transform: "translate(-38.462 -29.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11010",
    "data-name": "Group 11010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11009",
    "data-name": "Group 11009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11008",
    "data-name": "Group 11008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11007",
    "data-name": "Group 11007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6513",
    "data-name": "Path 6513",
    d: "M433.831,221.857a1.557,1.557,0,0,1-.015-.234l-.016-.66q-.012-.909-.036-2.533c-.02-2.222-.048-5.417-.083-9.444l.15.15-48.649.1c.109-.111-.25.247.245-.248v3.292q0,1.637,0,3.248,0,3.222,0,6.331l-.242-.243,34.671.11,10.234.07,2.767.031.724.016a1.579,1.579,0,0,1,.256.016,1.145,1.145,0,0,1-.225.015l-.694.016-2.715.032-10.178.069-34.84.11h-.243v-.243q0-3.1,0-6.331,0-1.611,0-3.248v-3.292c.5-.5.139-.137.251-.248l48.649.1h.152v.151c-.035,4.066-.064,7.29-.083,9.533q-.024,1.6-.037,2.5c-.006.26-.011.468-.016.633A.951.951,0,0,1,433.831,221.857Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11014",
    "data-name": "Group 11014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11013",
    "data-name": "Group 11013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11012",
    "data-name": "Group 11012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11011",
    "data-name": "Group 11011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6514",
    "data-name": "Path 6514",
    d: "M527.406,87.242a1.554,1.554,0,0,1-.015-.234c0-.172-.009-.389-.016-.66q-.012-.909-.036-2.533c-.02-2.222-.048-5.417-.084-9.444l.151.151-48.65.1c.11-.111-.25.247.245-.248v3.292q0,1.636,0,3.248,0,3.222,0,6.331L478.754,87l34.671.111,10.234.069,2.767.031.724.016a1.581,1.581,0,0,1,.256.016,1.193,1.193,0,0,1-.225.016l-.694.015-2.715.032-10.178.069-34.84.11h-.243v-.243q0-3.1,0-6.331,0-1.611,0-3.248V74.371c.5-.5.14-.137.251-.248l48.65.1h.152v.151c-.036,4.066-.064,7.29-.083,9.533q-.024,1.6-.037,2.5c-.006.26-.012.468-.016.633A.951.951,0,0,1,527.406,87.242Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11021",
    "data-name": "Group 11021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11017",
    "data-name": "Group 11017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11016",
    "data-name": "Group 11016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11015",
    "data-name": "Group 11015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6515",
    "data-name": "Path 6515",
    d: "M707.83,280.045a1.554,1.554,0,0,1-.015-.234l-.016-.66q-.014-.909-.037-2.533c-.019-2.222-.048-5.416-.083-9.444l.151.151-48.65.1c.11-.111-.25.247.245-.248v3.292q0,1.637,0,3.248,0,3.222,0,6.331l-.242-.243,34.671.111,10.234.069,2.767.032.724.015a1.761,1.761,0,0,1,.257.016,1.206,1.206,0,0,1-.226.016l-.694.015-2.715.032-10.178.069-34.84.11h-.242v-.243q0-3.105,0-6.331,0-1.611,0-3.248v-3.292c.5-.5.139-.137.251-.248l48.65.1h.152v.151c-.036,4.066-.064,7.291-.084,9.534q-.024,1.6-.036,2.5l-.016.634A.945.945,0,0,1,707.83,280.045Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11020",
    "data-name": "Group 11020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11019",
    "data-name": "Group 11019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11018",
    "data-name": "Group 11018"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6516",
    "data-name": "Path 6516",
    d: "M714.426,267.174a1.444,1.444,0,0,1-.018-.245c-.005-.185-.012-.409-.02-.682q-.015-.951-.044-2.581c-.023-2.257-.056-5.444-.1-9.363l.178.178-29.23.07c-.223.221.3-.3.246-.247v3.353q0,1.659,0,3.276c0,2.153-.006,4.241-.009,6.241l-.236-.236,20.911.112,6.092.065,1.642.03a4.949,4.949,0,0,1,.587.029,3.426,3.426,0,0,1-.53.029l-1.594.03-6.037.065-21.071.112h-.236v-.237c0-2-.006-4.088-.009-6.241q0-1.616,0-3.276V254.3c-.054.052.47-.471.25-.249l29.23.07h.18l0,.178c-.04,3.965-.072,7.189-.1,9.472q-.028,1.6-.045,2.54A7.009,7.009,0,0,1,714.426,267.174Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11060",
    "data-name": "Group 11060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11041",
    "data-name": "Group 11041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11040",
    "data-name": "Group 11040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11039",
    "data-name": "Group 11039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11029",
    "data-name": "Group 11029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11028",
    "data-name": "Group 11028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11027",
    "data-name": "Group 11027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11023",
    "data-name": "Group 11023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11022",
    "data-name": "Group 11022"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6517",
    "data-name": "Path 6517",
    d: "M254.554,424.621l-11.025,4.729.74-65.255c.346-7.806-3.248-11.139-5.2-13.359-17.705-20.132-44.116-5.53-44.348,14.887l-.662,58.311-10.713-.122,1.065-61.019c.078-6.875,5.419-18.8,10.808-23.065,29.8-23.6,60.289.786,60,26.582Z",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11026",
    "data-name": "Group 11026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11025",
    "data-name": "Group 11025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11024",
    "data-name": "Group 11024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6518",
    "data-name": "Path 6518",
    d: "M254.554,424.621s-.008-.4-.005-1.166.01-1.9.019-3.385c.023-2.976.057-7.347.1-12.973s.11-12.5.18-20.484q.057-5.984.121-12.776c-.042-4.513.408-9.331-.516-14.266a34.7,34.7,0,0,0-6.136-14.309c-.408-.547-.8-1.112-1.225-1.652l-1.382-1.553a36.147,36.147,0,0,0-3.009-2.948c-.517-.486-1.117-.879-1.675-1.326a20.455,20.455,0,0,0-1.741-1.27,33.663,33.663,0,0,0-3.78-2.186,36.3,36.3,0,0,0-8.417-3.016l-2.256-.37-1.135-.186c-.382-.039-.767-.051-1.152-.078l-2.317-.143c-.776-.012-1.556.051-2.338.072a35.1,35.1,0,0,0-18.081,6.023,35.308,35.308,0,0,0-15.354,25.546c-.3,3.507-.219,7.113-.287,10.725-.163,14.471-.331,29.453-.5,44.8-.023,2.049-.046,4.092-.069,6.117l-.248-.254,10.713.123-.253.247c.133-11.6.264-22.944.391-33.969q.1-8.27.19-16.29.048-4.008.093-7.948a27.494,27.494,0,0,1,1.293-7.744,25.289,25.289,0,0,1,8.861-12.194c.514-.354.987-.768,1.532-1.069l1.6-.947a27.108,27.108,0,0,1,6.878-2.474c.591-.122,1.192-.179,1.786-.271l.89-.125.9-.036a25.175,25.175,0,0,1,7.024.588,26.679,26.679,0,0,1,6.421,2.45,25.327,25.327,0,0,1,9.4,9.067,24.015,24.015,0,0,1,3.561,11.749q.028.75.056,1.492-.009.738-.019,1.469-.018,1.461-.036,2.9-.036,2.87-.07,5.63c-.094,7.359-.181,14.123-.259,20.223-.168,12.192-.3,21.728-.386,28.071l-.073-.074,8.078.134,1.977.039c.436.01.658.022.658.022s-.2.006-.633.006l-1.96-.005-8.121-.049h-.074V424.5c.057-6.343.142-15.88.251-28.072.061-6.1.128-12.865.2-20.224q.029-2.76.057-5.63.015-1.436.03-2.9.008-.73.015-1.468-.03-.732-.059-1.47a23.625,23.625,0,0,0-3.529-11.565,24.937,24.937,0,0,0-9.268-8.907,26.178,26.178,0,0,0-6.317-2.4,24.747,24.747,0,0,0-6.9-.569l-.881.036-.875.125c-.582.091-1.173.147-1.754.268a26.682,26.682,0,0,0-6.753,2.438l-1.57.932c-.536.3-1,.7-1.5,1.052a24.846,24.846,0,0,0-8.688,11.981,27.015,27.015,0,0,0-1.262,7.6q-.043,3.939-.087,7.948-.089,8.016-.18,16.289c-.123,11.026-.25,22.372-.38,33.97l0,.25-.25,0-10.713-.121-.251,0,0-.251q.034-3.037.069-6.116c.176-15.346.348-30.328.514-44.8.071-3.62-.01-7.194.3-10.771a35.851,35.851,0,0,1,15.578-25.878,35.534,35.534,0,0,1,18.319-6.081c.791-.021,1.581-.083,2.366-.069l2.689.168,1.48.168,2.247.372,1.036.219a35.288,35.288,0,0,1,8.005,2.932,34.026,34.026,0,0,1,3.821,2.218,20.707,20.707,0,0,1,1.759,1.288c.564.453,1.17.852,1.692,1.344A36.167,36.167,0,0,1,246,341.791l1.394,1.572c.431.547.825,1.119,1.236,1.673a35.017,35.017,0,0,1,6.171,14.471c.922,5,.456,9.839.485,14.364q-.09,6.807-.169,12.82c-.112,7.993-.207,14.879-.286,20.511-.083,5.61-.148,9.969-.192,12.936-.025,1.467-.044,2.587-.057,3.353S254.554,424.621,254.554,424.621Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11033",
    "data-name": "Group 11033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11032",
    "data-name": "Group 11032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11031",
    "data-name": "Group 11031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11030",
    "data-name": "Group 11030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_502",
    "data-name": "Rectangle 502",
    d: "M0,0H96.959A3.744,3.744,0,0,1,100.7,3.744V78.671a3.4,3.4,0,0,1-3.4,3.4H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(171.138 385.725) rotate(0.65)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11037",
    "data-name": "Group 11037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11036",
    "data-name": "Group 11036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11035",
    "data-name": "Group 11035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11034",
    "data-name": "Group 11034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_503",
    "data-name": "Rectangle 503",
    d: "M4.064,0h85.3a4.064,4.064,0,0,1,4.064,4.064V77.1a4.971,4.971,0,0,1-4.971,4.971H4.2a4.2,4.2,0,0,1-4.2-4.2V4.064A4.064,4.064,0,0,1,4.064,0Z",
    transform: "translate(166.545 385.673) rotate(0.65)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11038",
    "data-name": "Group 11038"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6519",
    "data-name": "Path 6519",
    d: "M225.854,420.153a11.459,11.459,0,0,0-11.68-11.587A11.587,11.587,0,0,0,202.938,419.8a11.423,11.423,0,0,0,8.206,11.165l-7.655,15.724,19.747.587-5.84-16.24A11.426,11.426,0,0,0,225.854,420.153Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11044",
    "data-name": "Group 11044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11043",
    "data-name": "Group 11043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11042",
    "data-name": "Group 11042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6520",
    "data-name": "Path 6520",
    d: "M259.18,461.094c-.139,0-.028-14.294.248-31.918s.611-31.916.75-31.914.027,14.291-.248,31.922S259.319,461.1,259.18,461.094Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11047",
    "data-name": "Group 11047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11046",
    "data-name": "Group 11046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11045",
    "data-name": "Group 11045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6521",
    "data-name": "Path 6521",
    d: "M238.344,388.975c0,.138-12.576.275-28.086.3s-28.088-.058-28.089-.2,12.573-.275,28.089-.3S238.344,388.836,238.344,388.975Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11050",
    "data-name": "Group 11050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11049",
    "data-name": "Group 11049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11048",
    "data-name": "Group 11048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6522",
    "data-name": "Path 6522",
    d: "M202.5,426.058a2.483,2.483,0,0,1-.467-.72,11.113,11.113,0,0,1-.857-2.176,12.829,12.829,0,0,1,4.7-13.845,11.187,11.187,0,0,1,2.005-1.2,2.508,2.508,0,0,1,.808-.287c.043.084-1.092.55-2.594,1.771a13.2,13.2,0,0,0-4.575,13.477C201.963,424.957,202.581,426.017,202.5,426.058Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11053",
    "data-name": "Group 11053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11052",
    "data-name": "Group 11052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11051",
    "data-name": "Group 11051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6523",
    "data-name": "Path 6523",
    d: "M206.962,431.54c-.073.118-.746-.169-1.5-.64s-1.31-.948-1.237-1.065.746.168,1.5.639S207.036,431.422,206.962,431.54Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11056",
    "data-name": "Group 11056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11055",
    "data-name": "Group 11055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11054",
    "data-name": "Group 11054"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6524",
    "data-name": "Path 6524",
    d: "M216.518,333.173c0,.044-.691.1-1.93.252a32.236,32.236,0,0,0-5.163,1.106,30.788,30.788,0,0,0-21.809,24.735,32.179,32.179,0,0,0-.45,5.26c0,1.249.035,1.943-.008,1.946a1.872,1.872,0,0,1-.079-.5c-.026-.329-.1-.815-.109-1.444a28.3,28.3,0,0,1,.295-5.318,30.376,30.376,0,0,1,22.062-25.021,28.156,28.156,0,0,1,5.24-.959c.625-.07,1.116-.058,1.446-.074A1.953,1.953,0,0,1,216.518,333.173Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11059",
    "data-name": "Group 11059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11058",
    "data-name": "Group 11058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11057",
    "data-name": "Group 11057"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6525",
    "data-name": "Path 6525",
    d: "M186.643,375.317a17.813,17.813,0,0,1,.126-5.959,17.813,17.813,0,0,1-.126,5.959Z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11066",
    "data-name": "Group 11066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11062",
    "data-name": "Group 11062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11061",
    "data-name": "Group 11061"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_504",
    "data-name": "Rectangle 504",
    width: 48.653,
    height: 12.871,
    transform: "translate(199.621 96.771)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11065",
    "data-name": "Group 11065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11064",
    "data-name": "Group 11064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11063",
    "data-name": "Group 11063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6526",
    "data-name": "Path 6526",
    d: "M227.7,123.2a1.553,1.553,0,0,1-.015-.234l-.016-.66q-.012-.908-.036-2.533c-.02-2.222-.048-5.416-.084-9.444l.151.151-48.65.1c.11-.11-.25.247.245-.247v3.291q0,1.636,0,3.248,0,3.224,0,6.331l-.242-.242,34.671.11,10.234.069,2.767.032.724.016a1.854,1.854,0,0,1,.256.015,1.089,1.089,0,0,1-.225.016l-.694.016-2.715.031-10.178.07-34.84.11h-.243V123.2q0-3.1,0-6.331,0-1.611,0-3.248v-3.291c.5-.5.14-.138.251-.249l48.65.1h.152v.15c-.036,4.066-.064,7.291-.083,9.534q-.024,1.6-.037,2.5c-.006.26-.012.468-.016.634A.948.948,0,0,1,227.7,123.2Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11072",
    "data-name": "Group 11072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11068",
    "data-name": "Group 11068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11067",
    "data-name": "Group 11067"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_505",
    "data-name": "Rectangle 505",
    width: 48.653,
    height: 12.871,
    transform: "translate(652.01 63.172)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11071",
    "data-name": "Group 11071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11070",
    "data-name": "Group 11070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11069",
    "data-name": "Group 11069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6527",
    "data-name": "Path 6527",
    d: "M680.09,89.6a1.57,1.57,0,0,1-.015-.234l-.016-.661q-.014-.908-.036-2.533c-.02-2.222-.048-5.416-.084-9.443l.151.15-48.65.1c.11-.11-.25.248.245-.247v3.292q0,1.635,0,3.248,0,3.222,0,6.33l-.243-.242,34.672.11,10.233.069,2.768.032.724.016a1.581,1.581,0,0,1,.256.016,1.161,1.161,0,0,1-.225.015l-.694.016-2.715.032-10.178.069-34.841.11H631.2V89.6q0-3.1,0-6.33,0-1.612,0-3.248V76.729c.5-.5.14-.138.251-.248l48.65.1h.152v.151c-.036,4.065-.064,7.29-.084,9.533q-.022,1.6-.036,2.5c-.007.26-.012.469-.016.634A.96.96,0,0,1,680.09,89.6Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11078",
    "data-name": "Group 11078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11074",
    "data-name": "Group 11074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11073",
    "data-name": "Group 11073"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506",
    "data-name": "Rectangle 506",
    width: 48.653,
    height: 12.871,
    transform: "translate(374.559 319.031)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11077",
    "data-name": "Group 11077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11076",
    "data-name": "Group 11076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11075",
    "data-name": "Group 11075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6528",
    "data-name": "Path 6528",
    d: "M402.639,345.459a1.554,1.554,0,0,1-.015-.234l-.016-.66q-.012-.909-.036-2.533c-.02-2.222-.048-5.417-.084-9.444l.151.15-48.65.1c.11-.111-.25.247.245-.248v3.292q0,1.637,0,3.248,0,3.222,0,6.331l-.242-.243,34.671.11,10.234.07,2.767.031.724.016a1.577,1.577,0,0,1,.256.016,1.165,1.165,0,0,1-.225.015l-.694.016-2.715.032-10.178.069-34.84.11h-.243v-.243q0-3.105,0-6.331,0-1.611,0-3.248v-3.292c.5-.5.139-.137.25-.248l48.65.1h.152v.151c-.036,4.066-.064,7.29-.083,9.533q-.024,1.6-.037,2.5c-.006.26-.012.468-.016.633A.954.954,0,0,1,402.639,345.459Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11082",
    "data-name": "Group 11082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11081",
    "data-name": "Group 11081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11080",
    "data-name": "Group 11080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11079",
    "data-name": "Group 11079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6529",
    "data-name": "Path 6529",
    d: "M589.411,447.73a1.554,1.554,0,0,1-.015-.234l-.015-.66q-.013-.909-.037-2.533c-.02-2.222-.048-5.416-.083-9.444l.15.151-48.649.1c.109-.111-.25.247.245-.248v3.292q0,1.637,0,3.248,0,3.222,0,6.331l-.242-.242,34.671.11,10.234.069,2.767.032.724.015a1.91,1.91,0,0,1,.256.016,1.185,1.185,0,0,1-.225.016l-.694.015-2.715.032-10.178.069-34.84.11h-.243v-.243q0-3.105,0-6.331,0-1.611,0-3.248v-3.292c.5-.5.139-.137.251-.248l48.649.1h.152v.15c-.035,4.066-.064,7.29-.083,9.534q-.024,1.6-.037,2.5c-.006.26-.011.468-.016.633A.952.952,0,0,1,589.411,447.73Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11089",
    "data-name": "Group 11089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11085",
    "data-name": "Group 11085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11084",
    "data-name": "Group 11084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11083",
    "data-name": "Group 11083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6530",
    "data-name": "Path 6530",
    d: "M87.362,365.025a1.555,1.555,0,0,1-.015-.234c0-.173-.009-.39-.015-.66q-.014-.909-.037-2.534c-.02-2.221-.048-5.416-.083-9.443l.15.15-48.649.1c.109-.11-.251.248.245-.247v3.292q0,1.636,0,3.248,0,3.222,0,6.33l-.242-.242,34.671.11,10.234.07,2.767.031.724.016a1.57,1.57,0,0,1,.256.016,1.146,1.146,0,0,1-.225.015l-.694.016-2.715.032-10.178.069-34.84.11h-.243v-.244q0-3.1,0-6.33,0-1.611,0-3.248v-3.292c.5-.5.139-.138.251-.248l48.649.1h.152v.151c-.035,4.066-.064,7.29-.083,9.533q-.024,1.6-.037,2.5l-.016.634A.952.952,0,0,1,87.362,365.025Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11088",
    "data-name": "Group 11088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11087",
    "data-name": "Group 11087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11086",
    "data-name": "Group 11086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6531",
    "data-name": "Path 6531",
    d: "M93.959,352.154a1.522,1.522,0,0,1-.019-.245c-.005-.185-.011-.409-.019-.682q-.016-.951-.044-2.581c-.023-2.257-.056-5.444-.1-9.363l.178.178-29.23.07c-.223.221.3-.3.246-.247v3.353q0,1.659,0,3.276c0,2.153-.006,4.241-.008,6.241l-.236-.236,20.911.112,6.091.065,1.643.03a4.74,4.74,0,0,1,.587.029,3.6,3.6,0,0,1-.531.029l-1.593.029-6.038.066-21.07.112h-.236v-.237c0-2-.006-4.088-.009-6.241q0-1.615,0-3.276v-3.353c-.055.052.47-.471.25-.249l29.23.069h.18l0,.178c-.04,3.964-.073,7.188-.1,9.471q-.027,1.605-.044,2.541A7.582,7.582,0,0,1,93.959,352.154Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11096",
    "data-name": "Group 11096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11092",
    "data-name": "Group 11092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11091",
    "data-name": "Group 11091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11090",
    "data-name": "Group 11090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6532",
    "data-name": "Path 6532",
    d: "M240.559,259.193a1.569,1.569,0,0,1-.015-.234l-.016-.661q-.014-.908-.037-2.533c-.019-2.222-.048-5.416-.083-9.443l.15.15-48.649.1c.109-.11-.25.248.245-.247v3.292q0,1.635,0,3.248,0,3.222,0,6.33l-.242-.242,34.671.11,10.234.069,2.767.032.724.016a1.606,1.606,0,0,1,.257.016,1.165,1.165,0,0,1-.226.015l-.694.016-2.715.032-10.178.069-34.84.11h-.242v-.244q0-3.1,0-6.33,0-1.612,0-3.248v-3.292c.5-.5.139-.138.251-.248l48.649.1h.153l0,.151c-.035,4.065-.063,7.29-.083,9.533q-.024,1.6-.037,2.5l-.015.634A.953.953,0,0,1,240.559,259.193Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11095",
    "data-name": "Group 11095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11094",
    "data-name": "Group 11094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11093",
    "data-name": "Group 11093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6533",
    "data-name": "Path 6533",
    d: "M247.155,246.322a1.483,1.483,0,0,1-.018-.245c-.006-.185-.012-.409-.02-.682l-.044-2.581c-.023-2.257-.056-5.444-.1-9.363l.178.178-29.23.07c-.223.221.3-.3.246-.247V236.8q0,1.659,0,3.276c0,2.153-.006,4.24-.009,6.24l-.236-.235,20.911.112,6.092.065,1.642.03a4.71,4.71,0,0,1,.587.029,3.6,3.6,0,0,1-.53.029l-1.594.029-6.038.065-21.07.112-.236,0v-.238c0-2-.006-4.087-.009-6.24q0-1.615,0-3.276v-3.353c-.054.052.47-.471.25-.249l29.23.069h.18l0,.178c-.04,3.964-.072,7.188-.1,9.471q-.027,1.605-.044,2.541A7,7,0,0,1,247.155,246.322Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Texts"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11155",
    "data-name": "Group 11155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11111",
    "data-name": "Group 11111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11100",
    "data-name": "Group 11100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11097",
    "data-name": "Group 11097"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_507",
    "data-name": "Rectangle 507",
    width: 227.005,
    height: 291.337,
    transform: "translate(456.374 126.896)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11099",
    "data-name": "Group 11099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11098",
    "data-name": "Group 11098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6534",
    "data-name": "Path 6534",
    d: "M683.379,418.234c0-2.054-.1-118.426-.234-291.337l.234.233-226.98.027h-.025l.26-.26c-.017,108.072-.032,208.408-.045,291.337l-.215-.216,227.005.216-227.005.215h-.216v-.215c-.012-82.929-.028-183.265-.045-291.337v-.261h.286l226.98.027h.234v.234C683.474,299.808,683.381,416.181,683.379,418.234Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11108",
    "data-name": "Group 11108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11107",
    "data-name": "Group 11107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11101",
    "data-name": "Group 11101"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_508",
    "data-name": "Rectangle 508",
    width: 182.345,
    height: 31.499,
    rx: 1.454,
    transform: "translate(479.054 238.045)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11102",
    "data-name": "Group 11102"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_509",
    "data-name": "Rectangle 509",
    width: 182.345,
    height: 31.499,
    rx: 1.454,
    transform: "translate(479.233 281.306)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11103",
    "data-name": "Group 11103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6535",
    "data-name": "Path 6535",
    d: "M498.968,251.978c0,1.581-1.144,2.539-3.039,2.539h-1.8v2.206h-1.041v-7.285h2.841C497.824,249.438,498.968,250.4,498.968,251.978Zm-1.041,0c0-1.041-.7-1.634-2.029-1.634h-1.769v3.268H495.9C497.23,253.612,497.927,253.018,497.927,251.978Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6536",
    "data-name": "Path 6536",
    d: "M504.667,253.393v3.33h-.947v-.728a2.048,2.048,0,0,1-1.811.79c-1.248,0-2.039-.665-2.039-1.624,0-.883.572-1.612,2.217-1.612h1.581v-.2c0-.843-.489-1.332-1.478-1.332a2.786,2.786,0,0,0-1.748.594l-.416-.75a3.669,3.669,0,0,1,2.278-.707C503.814,251.156,504.667,251.884,504.667,253.393Zm-1,1.644v-.77h-1.54c-.989,0-1.27.385-1.27.853,0,.551.458.9,1.218.9A1.6,1.6,0,0,0,503.668,255.037Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6537",
    "data-name": "Path 6537",
    d: "M505.819,256.14l.416-.791a3.547,3.547,0,0,0,1.935.572c.926,0,1.312-.28,1.312-.749,0-1.238-3.486-.166-3.486-2.362,0-.988.884-1.654,2.3-1.654a4.018,4.018,0,0,1,2.009.5l-.426.791a2.881,2.881,0,0,0-1.593-.437c-.874,0-1.3.322-1.3.759,0,1.3,3.5.24,3.5,2.384,0,1-.916,1.633-2.384,1.633A3.981,3.981,0,0,1,505.819,256.14Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6538",
    "data-name": "Path 6538",
    d: "M511.03,256.14l.416-.791a3.546,3.546,0,0,0,1.935.572c.926,0,1.312-.28,1.312-.749,0-1.238-3.486-.166-3.486-2.362,0-.988.884-1.654,2.3-1.654a4.018,4.018,0,0,1,2.009.5l-.427.791a2.878,2.878,0,0,0-1.592-.437c-.874,0-1.3.322-1.3.759,0,1.3,3.5.24,3.5,2.384,0,1-.916,1.633-2.384,1.633A3.981,3.981,0,0,1,511.03,256.14Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6539",
    "data-name": "Path 6539",
    d: "M525.179,251.207l-2.06,5.516h-.957l-1.593-4.184-1.612,4.184H518l-2.05-5.516h.947l1.6,4.392,1.665-4.392h.842l1.634,4.413,1.645-4.413Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6540",
    "data-name": "Path 6540",
    d: "M525.518,253.965a2.867,2.867,0,1,1,2.872,2.82A2.744,2.744,0,0,1,525.518,253.965Zm4.724,0a1.859,1.859,0,1,0-3.715,0,1.86,1.86,0,1,0,3.715,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6541",
    "data-name": "Path 6541",
    d: "M535.6,251.156v.967a1.834,1.834,0,0,0-.229-.01,1.646,1.646,0,0,0-1.738,1.863v2.747h-1v-5.516h.957v.927A2.106,2.106,0,0,1,535.6,251.156Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6542",
    "data-name": "Path 6542",
    d: "M541.975,249v7.722h-.958v-.874a2.329,2.329,0,0,1-1.967.936,2.815,2.815,0,0,1,0-5.629,2.347,2.347,0,0,1,1.926.884V249Zm-.989,4.964a1.86,1.86,0,1,0-1.852,1.946A1.814,1.814,0,0,0,540.986,253.965Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11104",
    "data-name": "Group 11104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6543",
    "data-name": "Path 6543",
    d: "M492.5,298.378a3.683,3.683,0,0,1,3.86-3.725,3.6,3.6,0,0,1,2.769,1.134l-.677.656a2.7,2.7,0,0,0-2.05-.864,2.8,2.8,0,1,0,0,5.6,2.708,2.708,0,0,0,2.05-.875l.677.656a3.618,3.618,0,0,1-2.78,1.145A3.681,3.681,0,0,1,492.5,298.378Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6544",
    "data-name": "Path 6544",
    d: "M499.724,299.263a2.867,2.867,0,1,1,2.872,2.82A2.744,2.744,0,0,1,499.724,299.263Zm4.725,0a1.86,1.86,0,1,0-1.853,1.946A1.81,1.81,0,0,0,504.449,299.263Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6545",
    "data-name": "Path 6545",
    d: "M512.073,298.847v3.174h-1v-3.06c0-1.082-.541-1.613-1.488-1.613a1.639,1.639,0,0,0-1.749,1.832v2.841h-1v-5.516h.957v.832a2.369,2.369,0,0,1,1.988-.884A2.137,2.137,0,0,1,512.073,298.847Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6546",
    "data-name": "Path 6546",
    d: "M515.888,294.237a1.86,1.86,0,0,1,1.124.322l-.3.76a1.293,1.293,0,0,0-.771-.26c-.593,0-.9.333-.9.968v.478h1.6v.822h-1.582v4.694h-1v-4.694h-.937v-.822h.937v-.489A1.658,1.658,0,0,1,515.888,294.237Zm2.363.561a.657.657,0,0,1,.675-.655.651.651,0,1,1-.675.655Zm.176,1.707h1v5.516h-1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    d: "M524.293,296.453v.968a1.692,1.692,0,0,0-.23-.011,1.646,1.646,0,0,0-1.737,1.864v2.747h-1v-5.516h.957v.926A2.105,2.105,0,0,1,524.293,296.453Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6548",
    "data-name": "Path 6548",
    d: "M534.675,298.847v3.174h-1v-3.06c0-1.082-.52-1.613-1.425-1.613a1.6,1.6,0,0,0-1.655,1.832v2.841h-1v-3.06c0-1.082-.52-1.613-1.426-1.613a1.6,1.6,0,0,0-1.654,1.832v2.841h-1v-5.516h.957v.822a2.236,2.236,0,0,1,1.9-.874,2.044,2.044,0,0,1,1.916,1.02,2.486,2.486,0,0,1,2.123-1.02A2.115,2.115,0,0,1,534.675,298.847Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6549",
    "data-name": "Path 6549",
    d: "M545.336,297.276c0,1.581-1.145,2.539-3.04,2.539h-1.8v2.206h-1.041v-7.285h2.84C544.191,294.736,545.336,295.694,545.336,297.276Zm-1.041,0c0-1.041-.7-1.635-2.03-1.635H540.5v3.268h1.768C543.6,298.909,544.295,298.316,544.295,297.276Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6550",
    "data-name": "Path 6550",
    d: "M551.034,298.691v3.33h-.947v-.729a2.049,2.049,0,0,1-1.811.791c-1.248,0-2.039-.666-2.039-1.624,0-.883.572-1.612,2.217-1.612h1.581v-.2c0-.843-.489-1.332-1.478-1.332a2.791,2.791,0,0,0-1.748.593l-.416-.75a3.671,3.671,0,0,1,2.278-.707C550.181,296.453,551.034,297.182,551.034,298.691Zm-1,1.643v-.769h-1.54c-.989,0-1.27.385-1.27.853,0,.551.458.895,1.218.895A1.6,1.6,0,0,0,550.035,300.334Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6551",
    "data-name": "Path 6551",
    d: "M552.186,301.438l.416-.791a3.547,3.547,0,0,0,1.936.572c.925,0,1.311-.28,1.311-.749,0-1.238-3.486-.167-3.486-2.362,0-.988.885-1.655,2.3-1.655a4.017,4.017,0,0,1,2.008.5l-.426.792a2.882,2.882,0,0,0-1.593-.438c-.874,0-1.3.323-1.3.76,0,1.3,3.5.239,3.5,2.384,0,1-.916,1.633-2.384,1.633A3.981,3.981,0,0,1,552.186,301.438Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6552",
    "data-name": "Path 6552",
    d: "M557.4,301.438l.416-.791a3.547,3.547,0,0,0,1.936.572c.925,0,1.311-.28,1.311-.749,0-1.238-3.486-.167-3.486-2.362,0-.988.885-1.655,2.3-1.655a4.017,4.017,0,0,1,2.008.5l-.426.792a2.882,2.882,0,0,0-1.593-.438c-.874,0-1.3.323-1.3.76,0,1.3,3.5.239,3.5,2.384,0,1-.916,1.633-2.384,1.633A3.981,3.981,0,0,1,557.4,301.438Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M571.546,296.505l-2.06,5.516h-.957l-1.593-4.184-1.612,4.184h-.958l-2.05-5.516h.947l1.6,4.392,1.665-4.392h.843l1.633,4.412,1.645-4.412Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M571.885,299.263a2.867,2.867,0,1,1,2.872,2.82A2.744,2.744,0,0,1,571.885,299.263Zm4.724,0a1.86,1.86,0,1,0-1.852,1.946A1.809,1.809,0,0,0,576.609,299.263Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M581.965,296.453v.968a1.67,1.67,0,0,0-.229-.011A1.646,1.646,0,0,0,580,299.274v2.747h-1v-5.516h.957v.926A2.1,2.1,0,0,1,581.965,296.453Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M588.342,294.3v7.722h-.958v-.874a2.328,2.328,0,0,1-1.966.936,2.815,2.815,0,0,1,0-5.63,2.349,2.349,0,0,1,1.925.884V294.3Zm-.989,4.964a1.86,1.86,0,1,0-1.851,1.946A1.815,1.815,0,0,0,587.353,299.263Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11105",
    "data-name": "Group 11105"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_510",
    "data-name": "Rectangle 510",
    width: 182.345,
    height: 31.499,
    rx: 1.454,
    transform: "translate(478.175 330.094)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11106",
    "data-name": "Group 11106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M546.789,346.083a3.768,3.768,0,0,1,4.006-3.788,3.85,3.85,0,0,1,3.132,1.374l-1.31,1.187A2.153,2.153,0,0,0,550.9,344a2.082,2.082,0,0,0,0,4.163,2.152,2.152,0,0,0,1.717-.853l1.31,1.186a3.852,3.852,0,0,1-3.132,1.373A3.767,3.767,0,0,1,546.789,346.083Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M560.754,346.5v3.226h-1.977v-2.9c0-.812-.354-1.156-.926-1.156-.635,0-1.124.4-1.124,1.332v2.727H554.75V342h1.977v2.6a2.448,2.448,0,0,1,1.7-.614A2.207,2.207,0,0,1,560.754,346.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M567.278,346.593v3.133h-1.842V349a1.708,1.708,0,0,1-1.665.823c-1.352,0-2.1-.76-2.1-1.739,0-1.04.759-1.685,2.507-1.685H565.3c-.031-.572-.417-.895-1.2-.895a2.624,2.624,0,0,0-1.529.489l-.666-1.342a4.732,4.732,0,0,1,2.487-.656C566.227,343.992,567.278,344.8,567.278,346.593Zm-1.977,1.322v-.489h-.853c-.635,0-.864.229-.864.572s.271.573.739.573A.974.974,0,0,0,565.3,347.915Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M574.531,346.5v3.226h-1.978v-2.9c0-.812-.353-1.156-.925-1.156-.635,0-1.124.4-1.124,1.332v2.727h-1.978v-5.641h1.884v.615a2.419,2.419,0,0,1,1.79-.708A2.207,2.207,0,0,1,574.531,346.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M581.92,344.085V348.7c0,2.133-1.208,3.142-3.31,3.142a4.97,4.97,0,0,1-2.8-.738l.719-1.385a3.263,3.263,0,0,0,1.9.6c1.062,0,1.509-.479,1.509-1.364v-.186a2.107,2.107,0,0,1-1.676.666,2.722,2.722,0,1,1,0-5.443,2.049,2.049,0,0,1,1.77.781v-.688Zm-1.958,2.623a1.236,1.236,0,0,0-2.465,0,1.235,1.235,0,0,0,2.465,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M588.922,347.406h-4.1a1.3,1.3,0,0,0,1.384.9,1.8,1.8,0,0,0,1.3-.489l1.041,1.082a3.055,3.055,0,0,1-2.4.916c-2.008,0-3.308-1.239-3.308-2.925a2.91,2.91,0,0,1,3.1-2.9,2.826,2.826,0,0,1,3.019,2.924C588.954,347.062,588.932,347.249,588.922,347.406Zm-4.131-1.041h2.31a1.173,1.173,0,0,0-2.31,0Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11109",
    "data-name": "Group 11109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    d: "M552.378,193.377H550.71v2.872h-3.058V185.44h4.941c2.95,0,4.8,1.529,4.8,4a3.587,3.587,0,0,1-2.116,3.413l2.332,3.4h-3.274Zm.03-5.528h-1.7v3.166h1.7c1.266,0,1.9-.587,1.9-1.576S553.674,187.849,552.408,187.849Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6564",
    "data-name": "Path 6564",
    d: "M567.45,192.806h-6.084a1.931,1.931,0,0,0,2.054,1.343,2.681,2.681,0,0,0,1.93-.725l1.544,1.606a4.531,4.531,0,0,1-3.567,1.359c-2.981,0-4.91-1.838-4.91-4.34a4.318,4.318,0,0,1,4.6-4.308,4.193,4.193,0,0,1,4.479,4.339C567.5,192.3,567.465,192.574,567.45,192.806Zm-6.13-1.544h3.428a1.741,1.741,0,0,0-3.428,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M568.193,195.524l.88-2.008a5.865,5.865,0,0,0,2.918.772c.988,0,1.313-.216,1.313-.571,0-1.127-4.941.154-4.941-3.2,0-1.575,1.451-2.779,4.076-2.779a7.347,7.347,0,0,1,3.3.71l-.88,1.992a4.909,4.909,0,0,0-2.409-.618c-.989,0-1.344.278-1.344.587,0,1.159,4.926-.092,4.926,3.228,0,1.544-1.42,2.749-4.138,2.749A7.684,7.684,0,0,1,568.193,195.524Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6566",
    "data-name": "Path 6566",
    d: "M585.813,192.806h-6.084a1.932,1.932,0,0,0,2.054,1.343,2.681,2.681,0,0,0,1.93-.725l1.544,1.606a4.53,4.53,0,0,1-3.567,1.359c-2.98,0-4.91-1.838-4.91-4.34a4.318,4.318,0,0,1,4.6-4.308,4.193,4.193,0,0,1,4.479,4.339C585.86,192.3,585.829,192.574,585.813,192.806Zm-6.13-1.544h3.428a1.741,1.741,0,0,0-3.428,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    d: "M592.995,195.91a3.944,3.944,0,0,1-2.038.479c-2.147,0-3.4-1.051-3.4-3.2v-2.811h-1.22v-2.192h1.22v-2.177h2.935v2.177h1.915v2.192h-1.915v2.78a.85.85,0,0,0,.88.958,1.6,1.6,0,0,0,.895-.263Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11110",
    "data-name": "Group 11110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6568",
    "data-name": "Path 6568",
    d: "M515.9,209.711v3.876H512.84v-3.922l-4.123-6.887h3.228l2.562,4.293,2.564-4.293h2.965Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6569",
    "data-name": "Path 6569",
    d: "M519.219,209.387c0-2.517,1.993-4.308,4.726-4.308,2.764,0,4.725,1.791,4.725,4.308,0,2.532-1.961,4.339-4.725,4.339C521.212,213.726,519.219,211.919,519.219,209.387Zm6.486,0a1.772,1.772,0,1,0-3.521,0,1.776,1.776,0,1,0,3.521,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6570",
    "data-name": "Path 6570",
    d: "M538.832,205.218v8.369h-2.795v-.9a3.3,3.3,0,0,1-2.487,1.034c-2.053,0-3.551-1.173-3.551-3.829v-4.679h2.933v4.2c0,1.3.51,1.806,1.39,1.806.865,0,1.575-.571,1.575-1.976v-4.03Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6571",
    "data-name": "Path 6571",
    d: "M546.323,205.079v2.64a5.326,5.326,0,0,0-.664-.046,1.826,1.826,0,0,0-2.008,2.069v3.845h-2.934v-8.369h2.8v1A3.425,3.425,0,0,1,546.323,205.079Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6572",
    "data-name": "Path 6572",
    d: "M561.936,206.777c0,2.456-1.853,3.985-4.8,3.985H555.25v2.825h-3.058V202.778h4.941C560.083,202.778,561.936,204.307,561.936,206.777Zm-3.089,0c0-1-.633-1.59-1.9-1.59h-1.7v3.165h1.7C558.214,208.352,558.847,207.765,558.847,206.777Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6573",
    "data-name": "Path 6573",
    d: "M571.047,208.939v4.648h-2.732v-1.081a2.536,2.536,0,0,1-2.471,1.22c-2.007,0-3.12-1.127-3.12-2.579,0-1.544,1.128-2.5,3.722-2.5h1.668c-.047-.849-.618-1.328-1.776-1.328a3.9,3.9,0,0,0-2.27.726l-.988-1.992a7.023,7.023,0,0,1,3.69-.973C569.488,205.079,571.047,206.283,571.047,208.939Zm-2.933,1.961v-.725h-1.267c-.941,0-1.281.34-1.281.849s.4.849,1.1.849A1.446,1.446,0,0,0,568.114,210.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6574",
    "data-name": "Path 6574",
    d: "M572.239,212.862l.88-2.008a5.866,5.866,0,0,0,2.919.772c.988,0,1.312-.216,1.312-.571,0-1.127-4.941.154-4.941-3.2,0-1.575,1.451-2.779,4.076-2.779a7.347,7.347,0,0,1,3.3.71l-.88,1.992a4.909,4.909,0,0,0-2.409-.618c-.989,0-1.344.278-1.344.587,0,1.159,4.926-.092,4.926,3.227,0,1.545-1.42,2.749-4.138,2.749A7.685,7.685,0,0,1,572.239,212.862Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6575",
    "data-name": "Path 6575",
    d: "M580.686,212.862l.88-2.008a5.866,5.866,0,0,0,2.919.772c.988,0,1.312-.216,1.312-.571,0-1.127-4.941.154-4.941-3.2,0-1.575,1.451-2.779,4.076-2.779a7.347,7.347,0,0,1,3.3.71l-.88,1.992a4.909,4.909,0,0,0-2.409-.618c-.988,0-1.344.278-1.344.587,0,1.159,4.926-.092,4.926,3.227,0,1.545-1.42,2.749-4.138,2.749A7.685,7.685,0,0,1,580.686,212.862Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6576",
    "data-name": "Path 6576",
    d: "M603.51,205.218l-2.98,8.369h-2.841l-1.575-4.555-1.637,4.555h-2.842l-2.979-8.369h2.779l1.714,5.065,1.775-5.065h2.5l1.73,5.111,1.776-5.111Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6577",
    "data-name": "Path 6577",
    d: "M603.652,209.387c0-2.517,1.992-4.308,4.726-4.308,2.763,0,4.724,1.791,4.724,4.308,0,2.532-1.961,4.339-4.724,4.339C605.644,213.726,603.652,211.919,603.652,209.387Zm6.485,0a1.772,1.772,0,1,0-3.52,0,1.775,1.775,0,1,0,3.52,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6578",
    "data-name": "Path 6578",
    d: "M620.067,205.079v2.64a5.3,5.3,0,0,0-.663-.046,1.826,1.826,0,0,0-2.008,2.069v3.845h-2.934v-8.369h2.8v1A3.426,3.426,0,0,1,620.067,205.079Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6579",
    "data-name": "Path 6579",
    d: "M630.091,202.129v11.458h-2.8v-.834a3.006,3.006,0,0,1-2.455.973,4.328,4.328,0,0,1,0-8.647,3.052,3.052,0,0,1,2.317.865v-3.815Zm-2.887,7.258a1.766,1.766,0,1,0-3.506,0,1.769,1.769,0,1,0,3.506,0Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11154",
    "data-name": "Group 11154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11135",
    "data-name": "Group 11135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11134",
    "data-name": "Group 11134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11133",
    "data-name": "Group 11133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11119",
    "data-name": "Group 11119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11118",
    "data-name": "Group 11118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11117",
    "data-name": "Group 11117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11113",
    "data-name": "Group 11113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11112",
    "data-name": "Group 11112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6580",
    "data-name": "Path 6580",
    d: "M600.17,137.831l-7.9-1.646L602.3,88.077a10.5,10.5,0,0,0-1.559-7.237c-12.588-17.426-33.072-10.345-36.209,4.707l-8.96,42.989-7.9-1.646,10.091-48.416a17.2,17.2,0,0,1,8.925-11.794c25.445-13.111,46.795,7.272,42.441,28.162Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11116",
    "data-name": "Group 11116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11115",
    "data-name": "Group 11115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11114",
    "data-name": "Group 11114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6581",
    "data-name": "Path 6581",
    d: "M600.17,137.831s.053-.3.166-.862.284-1.4.506-2.5c.449-2.2,1.11-5.42,1.96-9.571s1.9-9.221,3.108-15.109q.912-4.413,1.946-9.422c.624-3.341,1.657-6.835,1.691-10.617a26.122,26.122,0,0,0-2.455-11.463c-.222-.464-.429-.938-.665-1.4q-.4-.67-.8-1.348a27.015,27.015,0,0,0-1.795-2.615c-.311-.435-.7-.812-1.045-1.224a15.486,15.486,0,0,0-1.1-1.191,25.437,25.437,0,0,0-2.476-2.165,27.326,27.326,0,0,0-5.78-3.45l-1.614-.6-.811-.3c-.277-.084-.56-.149-.84-.225l-1.692-.442c-.571-.122-1.156-.189-1.737-.287A26.44,26.44,0,0,0,572.5,64.863a26.592,26.592,0,0,0-15.056,16.645c-.73,2.548-1.2,5.224-1.77,7.884-2.222,10.668-4.523,21.714-6.88,33.027q-.473,2.265-.94,4.509l-.146-.223,7.9,1.647-.223.146c1.784-8.55,3.528-16.915,5.224-25.043q1.272-6.1,2.507-12.008.617-2.955,1.223-5.86a20.7,20.7,0,0,1,2.08-5.534,19.051,19.051,0,0,1,8.318-7.723c.432-.186.841-.424,1.288-.567l1.32-.468a20.474,20.474,0,0,1,5.441-.828c.454-.005.907.041,1.359.059l.676.037.667.1a18.92,18.92,0,0,1,5.1,1.455,20,20,0,0,1,4.388,2.743,19.061,19.061,0,0,1,5.631,8.065,18.067,18.067,0,0,1,.924,9.2q-.089.557-.175,1.11-.114.543-.227,1.082l-.448,2.135q-.442,2.116-.87,4.15c-1.138,5.424-2.185,10.41-3.129,14.906-1.894,8.983-3.377,16.011-4.362,20.684l-.043-.065,5.948,1.273,1.455.316c.321.071.483.111.483.111s-.151-.024-.468-.087l-1.448-.288-5.993-1.216-.054-.012.011-.054c.963-4.679,2.412-11.713,4.264-20.706.93-4.5,1.963-9.487,3.086-14.914q.422-2.036.86-4.152.219-1.058.443-2.136.111-.539.224-1.083.086-.544.17-1.1a17.789,17.789,0,0,0-.928-9.058,18.764,18.764,0,0,0-5.554-7.927,19.8,19.8,0,0,0-4.318-2.691,18.7,18.7,0,0,0-5.02-1.423l-.656-.1-.664-.035c-.444-.017-.889-.062-1.335-.057a19.275,19.275,0,0,0-2.685.228,18.971,18.971,0,0,0-2.659.593l-1.3.46c-.439.141-.84.376-1.264.559a18.707,18.707,0,0,0-8.16,7.59,20.381,20.381,0,0,0-2.037,5.434q-.6,2.9-1.219,5.86l-2.5,12.01c-1.693,8.129-3.434,16.494-5.215,25.044l-.038.185-.185-.038-7.9-1.646-.185-.039.038-.185q.468-2.239.94-4.509c2.359-11.313,4.663-22.358,6.887-33.026.579-2.665,1.038-5.317,1.784-7.915a26.99,26.99,0,0,1,15.269-16.858,26.744,26.744,0,0,1,14.419-1.832c.588.1,1.18.168,1.759.292l1.962.515,1.069.339,1.606.6.734.313a26.575,26.575,0,0,1,5.489,3.329,25.878,25.878,0,0,1,2.5,2.194A15.463,15.463,0,0,1,603.02,71.5c.351.417.74.8,1.055,1.239a27.426,27.426,0,0,1,1.81,2.647l.8,1.364c.238.467.447.947.67,1.416a26.394,26.394,0,0,1,2.457,11.589c-.044,3.827-1.093,7.336-1.728,10.684q-1.056,5.016-1.988,9.447L602.908,125c-.876,4.133-1.557,7.344-2.021,9.53-.232,1.08-.409,1.9-.529,2.469S600.17,137.831,600.17,137.831Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11123",
    "data-name": "Group 11123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11122",
    "data-name": "Group 11122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11121",
    "data-name": "Group 11121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11120",
    "data-name": "Group 11120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511",
    d: "M0,0H72.089a3.744,3.744,0,0,1,3.744,3.744V58.4a3.4,3.4,0,0,1-3.4,3.4H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(544.186 96.974) rotate(11.773)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11127",
    "data-name": "Group 11127",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11126",
    "data-name": "Group 11126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11125",
    "data-name": "Group 11125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11124",
    "data-name": "Group 11124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_512",
    "data-name": "Rectangle 512",
    d: "M0,0H71.709a4.124,4.124,0,0,1,4.124,4.124v53.9A3.781,3.781,0,0,1,72.052,61.8H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(544.227 97.031) rotate(11.773)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11131",
    "data-name": "Group 11131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11130",
    "data-name": "Group 11130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11129",
    "data-name": "Group 11129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11128",
    "data-name": "Group 11128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_513",
    "data-name": "Rectangle 513",
    d: "M4.064,0H66.289a4.064,4.064,0,0,1,4.064,4.064V56.832A4.971,4.971,0,0,1,65.382,61.8H4.2A4.2,4.2,0,0,1,0,57.6V4.064A4.064,4.064,0,0,1,4.064,0Z",
    transform: "translate(540.8 96.269) rotate(11.773)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11132",
    "data-name": "Group 11132",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6582",
    "data-name": "Path 6582",
    d: "M579.613,130.361a8.629,8.629,0,0,0-6.947-10.258,8.727,8.727,0,0,0-9.933,6.665,8.6,8.6,0,0,0,4.442,9.442l-7.941,10.5,14.506,3.3-1.956-12.847A8.6,8.6,0,0,0,579.613,130.361Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11138",
    "data-name": "Group 11138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11137",
    "data-name": "Group 11137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11136",
    "data-name": "Group 11136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6583",
    "data-name": "Path 6583",
    d: "M598.29,165.453c-.1-.022,2.057-10.566,4.82-23.548s5.088-23.493,5.19-23.471-2.055,10.563-4.82,23.55S598.392,165.475,598.29,165.453Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11141",
    "data-name": "Group 11141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11140",
    "data-name": "Group 11140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11139",
    "data-name": "Group 11139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6584",
    "data-name": "Path 6584",
    d: "M593.371,109.138c-.02.1-9.332-1.623-20.8-3.854s-20.746-4.123-20.726-4.226,9.33,1.623,20.8,3.855S593.391,109.036,593.371,109.138Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11144",
    "data-name": "Group 11144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11143",
    "data-name": "Group 11143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11142",
    "data-name": "Group 11142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6585",
    "data-name": "Path 6585",
    d: "M561.5,131.331a1.892,1.892,0,0,1-.241-.6,8.415,8.415,0,0,1-.317-1.732,9.661,9.661,0,0,1,5.484-9.547,8.421,8.421,0,0,1,1.656-.6,1.847,1.847,0,0,1,.639-.094c.019.068-.887.247-2.174.931a9.943,9.943,0,0,0-5.338,9.294C561.263,130.44,561.566,131.313,561.5,131.331Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11147",
    "data-name": "Group 11147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11146",
    "data-name": "Group 11146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11145",
    "data-name": "Group 11145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6586",
    "data-name": "Path 6586",
    d: "M564,136.03c-.072.077-.527-.233-1.017-.69s-.831-.891-.76-.968.527.233,1.017.691S564.072,135.954,564,136.03Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11150",
    "data-name": "Group 11150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11149",
    "data-name": "Group 11149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11148",
    "data-name": "Group 11148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6587",
    "data-name": "Path 6587",
    d: "M585.35,64.737c0,.033-.524-.03-1.462-.1a24.342,24.342,0,0,0-3.975.067,23.188,23.188,0,0,0-19.708,15.109,24.317,24.317,0,0,0-1.1,3.821c-.182.923-.256,1.441-.288,1.437a1.435,1.435,0,0,1,.014-.381c.028-.247.045-.616.129-1.082a21.311,21.311,0,0,1,.991-3.887,22.872,22.872,0,0,1,19.935-15.283,21.17,21.17,0,0,1,4.011.053c.472.039.833.119,1.079.156A1.412,1.412,0,0,1,585.35,64.737Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11153",
    "data-name": "Group 11153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11152",
    "data-name": "Group 11152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11151",
    "data-name": "Group 11151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6588",
    "data-name": "Path 6588",
    d: "M557.154,91.537a6.824,6.824,0,0,1,.295-2.233,6.824,6.824,0,0,1,.664-2.152,6.822,6.822,0,0,1-.295,2.233A6.816,6.816,0,0,1,557.154,91.537Z",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Characters"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11517",
    "data-name": "Group 11517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11374",
    "data-name": "Group 11374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11260",
    "data-name": "Group 11260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11259",
    "data-name": "Group 11259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11169",
    "data-name": "Group 11169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11168",
    "data-name": "Group 11168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11167",
    "data-name": "Group 11167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11166",
    "data-name": "Group 11166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11165",
    "data-name": "Group 11165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11164",
    "data-name": "Group 11164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11163",
    "data-name": "Group 11163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11162",
    "data-name": "Group 11162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11161",
    "data-name": "Group 11161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11160",
    "data-name": "Group 11160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11159",
    "data-name": "Group 11159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11158",
    "data-name": "Group 11158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11157",
    "data-name": "Group 11157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11156",
    "data-name": "Group 11156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6589",
    "data-name": "Path 6589",
    d: "M60.422,413.6,42.447,438.011,72.706,460.53c1.975-3.023-9.361-20.476-9.361-20.476L75.5,424.884Z",
    fill: "#455a64"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11184",
    "data-name": "Group 11184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11183",
    "data-name": "Group 11183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11182",
    "data-name": "Group 11182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11181",
    "data-name": "Group 11181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11180",
    "data-name": "Group 11180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11179",
    "data-name": "Group 11179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11178",
    "data-name": "Group 11178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11177",
    "data-name": "Group 11177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11176",
    "data-name": "Group 11176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11175",
    "data-name": "Group 11175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11174",
    "data-name": "Group 11174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11173",
    "data-name": "Group 11173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11172",
    "data-name": "Group 11172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11171",
    "data-name": "Group 11171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11170",
    "data-name": "Group 11170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6590",
    "data-name": "Path 6590",
    d: "M54.964,431.78a1.54,1.54,0,0,0-1.9.774,1.481,1.481,0,0,0,.751,1.894,1.625,1.625,0,0,0,2.012-.831,1.535,1.535,0,0,0-1-1.883",
    fill: "#fff"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11198",
    "data-name": "Group 11198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11197",
    "data-name": "Group 11197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11196",
    "data-name": "Group 11196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11195",
    "data-name": "Group 11195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11194",
    "data-name": "Group 11194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11193",
    "data-name": "Group 11193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11192",
    "data-name": "Group 11192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11191",
    "data-name": "Group 11191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11190",
    "data-name": "Group 11190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11189",
    "data-name": "Group 11189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11188",
    "data-name": "Group 11188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11187",
    "data-name": "Group 11187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11186",
    "data-name": "Group 11186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11185",
    "data-name": "Group 11185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6591",
    "data-name": "Path 6591",
    d: "M42.407,438.06l1.913-2.623L72.591,458.2s.9,1.6.037,2.425Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11213",
    "data-name": "Group 11213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11212",
    "data-name": "Group 11212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11211",
    "data-name": "Group 11211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11210",
    "data-name": "Group 11210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11209",
    "data-name": "Group 11209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11208",
    "data-name": "Group 11208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11207",
    "data-name": "Group 11207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11206",
    "data-name": "Group 11206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11205",
    "data-name": "Group 11205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11204",
    "data-name": "Group 11204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11203",
    "data-name": "Group 11203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11202",
    "data-name": "Group 11202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11201",
    "data-name": "Group 11201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11200",
    "data-name": "Group 11200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11199",
    "data-name": "Group 11199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6592",
    "data-name": "Path 6592",
    d: "M63.95,440.265c-.115.144-.9-.339-1.984-.405-1.079-.094-1.93.267-2.023.108-.115-.13.763-.85,2.07-.747S64.083,440.153,63.95,440.265Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11228",
    "data-name": "Group 11228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11227",
    "data-name": "Group 11227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11226",
    "data-name": "Group 11226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11225",
    "data-name": "Group 11225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11224",
    "data-name": "Group 11224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11223",
    "data-name": "Group 11223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11222",
    "data-name": "Group 11222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11221",
    "data-name": "Group 11221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11220",
    "data-name": "Group 11220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11219",
    "data-name": "Group 11219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11218",
    "data-name": "Group 11218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11217",
    "data-name": "Group 11217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11216",
    "data-name": "Group 11216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11215",
    "data-name": "Group 11215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11214",
    "data-name": "Group 11214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6593",
    "data-name": "Path 6593",
    d: "M66.147,443.939c-.073.169-.9-.056-1.867.2-.974.223-1.6.8-1.746.689-.156-.08.386-1.022,1.594-1.312S66.248,443.8,66.147,443.939Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11243",
    "data-name": "Group 11243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11242",
    "data-name": "Group 11242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11241",
    "data-name": "Group 11241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11240",
    "data-name": "Group 11240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11239",
    "data-name": "Group 11239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11238",
    "data-name": "Group 11238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11237",
    "data-name": "Group 11237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11236",
    "data-name": "Group 11236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11235",
    "data-name": "Group 11235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11234",
    "data-name": "Group 11234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11233",
    "data-name": "Group 11233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11232",
    "data-name": "Group 11232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11231",
    "data-name": "Group 11231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11230",
    "data-name": "Group 11230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11229",
    "data-name": "Group 11229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6594",
    "data-name": "Path 6594",
    d: "M65.122,449.079c-.157-.068.187-.959,1.168-1.486s1.913-.335,1.883-.165c-.007.183-.778.284-1.578.728C65.786,448.582,65.28,449.174,65.122,449.079Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11258",
    "data-name": "Group 11258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11257",
    "data-name": "Group 11257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11256",
    "data-name": "Group 11256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11255",
    "data-name": "Group 11255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11254",
    "data-name": "Group 11254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11253",
    "data-name": "Group 11253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11252",
    "data-name": "Group 11252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11251",
    "data-name": "Group 11251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11250",
    "data-name": "Group 11250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11249",
    "data-name": "Group 11249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11248",
    "data-name": "Group 11248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11247",
    "data-name": "Group 11247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11246",
    "data-name": "Group 11246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11245",
    "data-name": "Group 11245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11244",
    "data-name": "Group 11244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6595",
    "data-name": "Path 6595",
    d: "M66.337,436.5c-.162.089-.688-.619-1.565-1.184-.867-.583-1.725-.786-1.708-.97-.005-.171,1.036-.245,2.06.434S66.5,436.438,66.337,436.5Z",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11262",
    "data-name": "Group 11262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11261",
    "data-name": "Group 11261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6596",
    "data-name": "Path 6596",
    d: "M133.576,311.456c.548,3.062,1.4,29.092,1.95,42.82s-.819,20.489-2.387,23.562S72.357,424.553,67.849,435L52.892,422.914s21.957-39.5,31.382-46.669S111.7,362.471,111.7,362.471l-5.123-75.194,24.587-1.341Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11373",
    "data-name": "Group 11373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11367",
    "data-name": "Group 11367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11366",
    "data-name": "Group 11366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11276",
    "data-name": "Group 11276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11275",
    "data-name": "Group 11275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11274",
    "data-name": "Group 11274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11273",
    "data-name": "Group 11273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11272",
    "data-name": "Group 11272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11271",
    "data-name": "Group 11271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11270",
    "data-name": "Group 11270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11269",
    "data-name": "Group 11269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11268",
    "data-name": "Group 11268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11267",
    "data-name": "Group 11267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11266",
    "data-name": "Group 11266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11265",
    "data-name": "Group 11265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11264",
    "data-name": "Group 11264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11263",
    "data-name": "Group 11263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6597",
    "data-name": "Path 6597",
    d: "M78.55,437.728l-.263,30.315,37.715.52c-.171-3.606-19.583-11.108-19.583-11.108l.965-19.417Z",
    fill: "#455a64"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11291",
    "data-name": "Group 11291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11290",
    "data-name": "Group 11290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11289",
    "data-name": "Group 11289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11288",
    "data-name": "Group 11288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11287",
    "data-name": "Group 11287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11286",
    "data-name": "Group 11286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11285",
    "data-name": "Group 11285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11284",
    "data-name": "Group 11284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11283",
    "data-name": "Group 11283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11282",
    "data-name": "Group 11282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11281",
    "data-name": "Group 11281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11280",
    "data-name": "Group 11280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11279",
    "data-name": "Group 11279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11278",
    "data-name": "Group 11278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11277",
    "data-name": "Group 11277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6598",
    "data-name": "Path 6598",
    d: "M84.78,455.66a1.539,1.539,0,0,0-1.089,1.743,1.48,1.48,0,0,0,1.718,1.095,1.626,1.626,0,0,0,1.143-1.852,1.536,1.536,0,0,0-1.913-.94",
    fill: "#fff"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11305",
    "data-name": "Group 11305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11304",
    "data-name": "Group 11304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11303",
    "data-name": "Group 11303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11302",
    "data-name": "Group 11302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11301",
    "data-name": "Group 11301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11300",
    "data-name": "Group 11300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11299",
    "data-name": "Group 11299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11298",
    "data-name": "Group 11298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11297",
    "data-name": "Group 11297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11296",
    "data-name": "Group 11296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11295",
    "data-name": "Group 11295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11294",
    "data-name": "Group 11294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11293",
    "data-name": "Group 11293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11292",
    "data-name": "Group 11292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6599",
    "data-name": "Path 6599",
    d: "M78.283,468.107l.014-3.246,36.248,1.883s1.664.764,1.45,1.943Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11320",
    "data-name": "Group 11320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11319",
    "data-name": "Group 11319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11318",
    "data-name": "Group 11318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11317",
    "data-name": "Group 11317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11316",
    "data-name": "Group 11316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11315",
    "data-name": "Group 11315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11314",
    "data-name": "Group 11314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11313",
    "data-name": "Group 11313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11312",
    "data-name": "Group 11312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11311",
    "data-name": "Group 11311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11310",
    "data-name": "Group 11310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11309",
    "data-name": "Group 11309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11308",
    "data-name": "Group 11308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11307",
    "data-name": "Group 11307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11306",
    "data-name": "Group 11306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6600",
    "data-name": "Path 6600",
    d: "M97.033,457.272c-.008.184-.93.254-1.845.834-.929.556-1.407,1.347-1.576,1.272-.169-.038.121-1.135,1.24-1.818S97.075,457.1,97.033,457.272Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11335",
    "data-name": "Group 11335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11334",
    "data-name": "Group 11334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11333",
    "data-name": "Group 11333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11332",
    "data-name": "Group 11332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11331",
    "data-name": "Group 11331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11330",
    "data-name": "Group 11330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11329",
    "data-name": "Group 11329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11328",
    "data-name": "Group 11328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11327",
    "data-name": "Group 11327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11326",
    "data-name": "Group 11326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11325",
    "data-name": "Group 11325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11324",
    "data-name": "Group 11324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11323",
    "data-name": "Group 11323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11322",
    "data-name": "Group 11322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11321",
    "data-name": "Group 11321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6601",
    "data-name": "Path 6601",
    d: "M100.966,458.962c.04.179-.762.481-1.4,1.252-.659.751-.828,1.591-1.012,1.581-.173.026-.286-1.054.524-2S100.965,458.786,100.966,458.962Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11350",
    "data-name": "Group 11350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11349",
    "data-name": "Group 11349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11348",
    "data-name": "Group 11348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11347",
    "data-name": "Group 11347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11346",
    "data-name": "Group 11346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11345",
    "data-name": "Group 11345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11344",
    "data-name": "Group 11344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11343",
    "data-name": "Group 11343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11342",
    "data-name": "Group 11342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11341",
    "data-name": "Group 11341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11340",
    "data-name": "Group 11340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11339",
    "data-name": "Group 11339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11338",
    "data-name": "Group 11338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11337",
    "data-name": "Group 11337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11336",
    "data-name": "Group 11336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6602",
    "data-name": "Path 6602",
    d: "M103.148,463.728c-.168.036-.412-.887.075-1.889s1.354-1.392,1.43-1.238c.1.153-.465.687-.852,1.516C103.395,462.936,103.331,463.712,103.148,463.728Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11365",
    "data-name": "Group 11365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11364",
    "data-name": "Group 11364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11363",
    "data-name": "Group 11363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11362",
    "data-name": "Group 11362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11361",
    "data-name": "Group 11361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11360",
    "data-name": "Group 11360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11359",
    "data-name": "Group 11359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11358",
    "data-name": "Group 11358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11357",
    "data-name": "Group 11357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11356",
    "data-name": "Group 11356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11355",
    "data-name": "Group 11355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11354",
    "data-name": "Group 11354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11353",
    "data-name": "Group 11353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11352",
    "data-name": "Group 11352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11351",
    "data-name": "Group 11351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6603",
    "data-name": "Path 6603",
    d: "M96.762,452.822c-.08.167-.921-.1-1.963-.042-1.043.035-1.858.373-1.951.214-.105-.135.695-.8,1.923-.855S96.854,452.679,96.762,452.822Z",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11369",
    "data-name": "Group 11369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11368",
    "data-name": "Group 11368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6604",
    "data-name": "Path 6604",
    d: "M136.3,282.827c0,1.775,2.868,46.578-11.777,78.974,0,0-5.074,10.136-5.962,14.573s-19.879,77.9-19.879,77.9l-21.9-.8s-3.506-36.813.044-58.115,10.033-18.816,10.033-32.574S83.594,320.5,83.594,320.5s-4.784-7.8-6.415-22.9c-1.325-12.274,4.448-25.419,4.448-25.419l5.716-10.113,48.308-2.532Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11372",
    "data-name": "Group 11372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11371",
    "data-name": "Group 11371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11370",
    "data-name": "Group 11370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6605",
    "data-name": "Path 6605",
    d: "M136.3,282.827s.006-.516-.012-1.524-.053-2.517-.1-4.481c-.1-3.953-.241-9.772-.426-17.288l0-.119-.12.006-48.311,2.456-.106,0-.052.092-5.726,10.107-.006.011,0,.008A65.039,65.039,0,0,0,78,283.182a49.478,49.478,0,0,0-1.206,12.187,75.469,75.469,0,0,0,1.966,12.693,51.9,51.9,0,0,0,4.63,12.565l-.034-.1c.83,7.465,1.6,15.195,2.246,23.152.321,3.979.605,8.016.8,12.107.1,2.045.173,4.1.189,6.173.036,1.038-.041,2.065-.06,3.1a27.062,27.062,0,0,1-.383,3.081,20.372,20.372,0,0,1-2.073,5.872c-.97,1.871-2.058,3.72-2.97,5.674a53.424,53.424,0,0,0-3.934,12.4c-1.745,8.6-2.1,17.542-2.193,26.544-.039,11.9.563,23.57,1.543,34.868l.02.231.234.009,21.9.794.209.007.052-.2c6.344-24.611,12.266-47.61,17.483-68.293q.963-3.882,1.9-7.654c.321-1.267.533-2.529.923-3.725s.828-2.387,1.29-3.549c.938-2.32,1.95-4.569,2.983-6.761q.393-.819.782-1.631a16.612,16.612,0,0,0,.739-1.64q.68-1.658,1.345-3.287a132.514,132.514,0,0,0,6.915-24.934,217.444,217.444,0,0,0,3.3-36.735c.056-8.626-.294-13.307-.294-13.307s-.006.293.007.867.037,1.437.066,2.554c.062,2.248.1,5.576.043,9.884a221.65,221.65,0,0,1-3.45,36.677,132.65,132.65,0,0,1-6.956,24.845q-.665,1.619-1.343,3.267a16.3,16.3,0,0,1-.74,1.631q-.392.813-.787,1.634c-1.039,2.2-2.057,4.448-3,6.778-.466,1.168-.918,2.355-1.307,3.578s-.62,2.511-.938,3.752q-.94,3.766-1.909,7.646c-5.31,20.659-11.223,43.66-17.55,68.273l.261-.194-21.9-.805.254.24c-.974-11.275-1.573-22.944-1.535-34.815.1-8.985.448-17.9,2.179-26.441a52.923,52.923,0,0,1,3.89-12.283c.9-1.932,1.978-3.765,2.96-5.66a20.9,20.9,0,0,0,2.119-6.016,27.49,27.49,0,0,0,.39-3.144c.019-1.049.1-2.1.058-3.139-.017-2.08-.091-4.144-.193-6.194-.2-4.1-.489-8.14-.813-12.123-.658-7.964-1.431-15.7-2.269-23.166l0-.046-.029-.053a51.532,51.532,0,0,1-4.588-12.423,75.061,75.061,0,0,1-1.971-12.6,49.051,49.051,0,0,1,1.177-12.077,64.636,64.636,0,0,1,3.4-11.008l-.009.018,5.7-10.119-.157.1,48.3-2.608-.122-.112c.233,7.513.414,13.331.537,17.283.068,1.963.12,3.46.155,4.48S136.3,282.827,136.3,282.827Z",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11515",
    "data-name": "Group 11515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11375",
    "data-name": "Group 11375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6606",
    "data-name": "Path 6606",
    d: "M120.589,191.069s-13.046-2.3-11.786,14.431c.755,10.019,3.7,27.157,5.326,38.114.563,3.786,1.8,10.569,6.808,14.55l35.9,24.845,11.33-13.545-32.056-30.538-5.038-30.2Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11512",
    "data-name": "Group 11512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11510",
    "data-name": "Group 11510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11509",
    "data-name": "Group 11509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11376",
    "data-name": "Group 11376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6607",
    "data-name": "Path 6607",
    d: "M122.116,130.774a16.422,16.422,0,0,1,6.1,13.918c-.2,2.554-.9,5.469.759,7.419,1.645,1.931,4.875,1.875,6.452,3.861,1.856,2.339.3,5.819.966,8.73a5.912,5.912,0,0,0,6.286,4.392,23.055,23.055,0,0,1-11.436,4.962l-3.2-4.108c1.212,1.438.89,3.73-.285,5.2a9.664,9.664,0,0,1-4.781,2.839,29.269,29.269,0,0,1-25.651-4.17",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11377",
    "data-name": "Group 11377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6608",
    "data-name": "Path 6608",
    d: "M74.092,153.344c.64-1.958,1.714-3.773,2.144-5.788.925-4.33-1.184-9.2.917-13.1,1.5-2.775,4.681-4.133,7.693-5.061s6.244-1.714,8.49-3.925c1.648-1.621,2.585-3.854,4.227-5.481,2.34-2.319,5.794-3.1,9.082-3.306a19.728,19.728,0,0,1,9.9,1.607,10.825,10.825,0,0,1,6.1,7.627c.264,1.628.064,3.334.577,4.9.564,1.724,1.918,3.065,2.753,4.675a8.674,8.674,0,0,1-2.169,10.4l-23.18,29.941c-4.869,1.839-16.668-.386-20.431-3.982S72.476,158.292,74.092,153.344Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11378",
    "data-name": "Group 11378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6609",
    "data-name": "Path 6609",
    d: "M123.2,142.086c-.955-6.8-6.125-14.83-12.876-13.587L89.48,135.5c-2.051.377-.582,3.722-.382,5.8l4.531,47c-.034.011-2.815,2.01-3.82,1.625a.283.283,0,0,0-.337.423c2.5,3.634,14.318,19.521,26.494,14.67,2.72-1.083-.285-9.654.034-12.829l-.362-8.112c-.27-4.141-.4-5.837-.4-5.8,0,0,8.616-2.12,9.548-13.645C125.256,158.9,124.258,149.639,123.2,142.086Z",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11392",
    "data-name": "Group 11392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11391",
    "data-name": "Group 11391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11390",
    "data-name": "Group 11390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11389",
    "data-name": "Group 11389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11388",
    "data-name": "Group 11388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11387",
    "data-name": "Group 11387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11386",
    "data-name": "Group 11386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11385",
    "data-name": "Group 11385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11384",
    "data-name": "Group 11384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11383",
    "data-name": "Group 11383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11382",
    "data-name": "Group 11382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11381",
    "data-name": "Group 11381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11380",
    "data-name": "Group 11380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11379",
    "data-name": "Group 11379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6610",
    "data-name": "Path 6610",
    d: "M121.745,152.549a1.464,1.464,0,0,1-1.3,1.581,1.4,1.4,0,0,1-1.606-1.2,1.466,1.466,0,0,1,1.293-1.583A1.4,1.4,0,0,1,121.745,152.549Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11406",
    "data-name": "Group 11406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11405",
    "data-name": "Group 11405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11404",
    "data-name": "Group 11404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11403",
    "data-name": "Group 11403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11402",
    "data-name": "Group 11402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11401",
    "data-name": "Group 11401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11400",
    "data-name": "Group 11400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11399",
    "data-name": "Group 11399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11398",
    "data-name": "Group 11398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11397",
    "data-name": "Group 11397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11396",
    "data-name": "Group 11396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11395",
    "data-name": "Group 11395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11394",
    "data-name": "Group 11394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11393",
    "data-name": "Group 11393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6611",
    "data-name": "Path 6611",
    d: "M107.554,153.438a1.465,1.465,0,0,1-1.295,1.581,1.4,1.4,0,0,1-1.607-1.2,1.467,1.467,0,0,1,1.293-1.583A1.4,1.4,0,0,1,107.554,153.438Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11421",
    "data-name": "Group 11421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11420",
    "data-name": "Group 11420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11419",
    "data-name": "Group 11419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11418",
    "data-name": "Group 11418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11417",
    "data-name": "Group 11417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11416",
    "data-name": "Group 11416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11415",
    "data-name": "Group 11415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11414",
    "data-name": "Group 11414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11413",
    "data-name": "Group 11413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11412",
    "data-name": "Group 11412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11411",
    "data-name": "Group 11411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11410",
    "data-name": "Group 11410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11409",
    "data-name": "Group 11409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11408",
    "data-name": "Group 11408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11407",
    "data-name": "Group 11407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6612",
    "data-name": "Path 6612",
    d: "M122.268,147.734c-.158.267-1.517-.592-3.218-.344-1.7.219-2.792,1.414-3.015,1.2-.107-.094.025-.555.5-1.092a3.879,3.879,0,0,1,4.975-.683C122.1,147.2,122.348,147.613,122.268,147.734Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11436",
    "data-name": "Group 11436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11435",
    "data-name": "Group 11435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11434",
    "data-name": "Group 11434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11433",
    "data-name": "Group 11433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11432",
    "data-name": "Group 11432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11431",
    "data-name": "Group 11431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11430",
    "data-name": "Group 11430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11429",
    "data-name": "Group 11429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11428",
    "data-name": "Group 11428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11427",
    "data-name": "Group 11427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11426",
    "data-name": "Group 11426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11425",
    "data-name": "Group 11425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11424",
    "data-name": "Group 11424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11423",
    "data-name": "Group 11423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11422",
    "data-name": "Group 11422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6613",
    "data-name": "Path 6613",
    d: "M106.994,148.995c-.2.246-1.538-.724-3.367-.646-1.83.05-3.127,1.112-3.336.88-.1-.1.09-.54.657-1.02a4.435,4.435,0,0,1,2.656-1,4.316,4.316,0,0,1,2.693.811C106.88,148.462,107.092,148.884,106.994,148.995Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11451",
    "data-name": "Group 11451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11450",
    "data-name": "Group 11450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11449",
    "data-name": "Group 11449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11448",
    "data-name": "Group 11448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11447",
    "data-name": "Group 11447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11446",
    "data-name": "Group 11446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11445",
    "data-name": "Group 11445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11444",
    "data-name": "Group 11444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11443",
    "data-name": "Group 11443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11442",
    "data-name": "Group 11442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11441",
    "data-name": "Group 11441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11440",
    "data-name": "Group 11440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11439",
    "data-name": "Group 11439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11438",
    "data-name": "Group 11438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11437",
    "data-name": "Group 11437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6614",
    "data-name": "Path 6614",
    d: "M112.728,159.766a10.434,10.434,0,0,1,2.517-.657c.4-.072.772-.181.818-.46a2.041,2.041,0,0,0-.359-1.169l-1.421-2.964c-1.982-4.223-3.45-7.708-3.279-7.786s1.916,3.281,3.9,7.5q.718,1.563,1.373,2.986a2.328,2.328,0,0,1,.329,1.559,1.014,1.014,0,0,1-.615.638,2.775,2.775,0,0,1-.674.147A10.24,10.24,0,0,1,112.728,159.766Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11465",
    "data-name": "Group 11465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11464",
    "data-name": "Group 11464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11463",
    "data-name": "Group 11463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11462",
    "data-name": "Group 11462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11461",
    "data-name": "Group 11461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11460",
    "data-name": "Group 11460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11459",
    "data-name": "Group 11459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11458",
    "data-name": "Group 11458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11457",
    "data-name": "Group 11457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11456",
    "data-name": "Group 11456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11455",
    "data-name": "Group 11455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11454",
    "data-name": "Group 11454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11453",
    "data-name": "Group 11453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11452",
    "data-name": "Group 11452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6615",
    "data-name": "Path 6615",
    d: "M115.243,178.277a29.044,29.044,0,0,1-15.561-2.9s4.447,7.7,15.761,5.755Z",
    fill: "#ff9a6c"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11466",
    "data-name": "Group 11466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6616",
    "data-name": "Path 6616",
    d: "M107.935,164.352a2.472,2.472,0,0,1,.806-.958,1.98,1.98,0,0,1,1.361-.137,3.172,3.172,0,0,1,1.78.9,1.912,1.912,0,0,1,.449,1.881h0c-.176.657-1.157,1.017-1.827,1.135a3,3,0,0,1-1.958-.412,1.73,1.73,0,0,1-1-1.3A2.114,2.114,0,0,1,107.935,164.352Z",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11481",
    "data-name": "Group 11481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11480",
    "data-name": "Group 11480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11479",
    "data-name": "Group 11479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11478",
    "data-name": "Group 11478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11477",
    "data-name": "Group 11477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11476",
    "data-name": "Group 11476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11475",
    "data-name": "Group 11475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11474",
    "data-name": "Group 11474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11473",
    "data-name": "Group 11473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11472",
    "data-name": "Group 11472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11471",
    "data-name": "Group 11471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11470",
    "data-name": "Group 11470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11469",
    "data-name": "Group 11469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11468",
    "data-name": "Group 11468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11467",
    "data-name": "Group 11467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6617",
    "data-name": "Path 6617",
    d: "M108.257,162.14c.254-.035.389,1.671,1.942,2.769s3.354.771,3.386,1.009c.032.1-.38.362-1.146.442a4.256,4.256,0,0,1-2.818-.746,3.709,3.709,0,0,1-1.519-2.33C107.982,162.576,108.14,162.139,108.257,162.14Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11492",
    "data-name": "Group 11492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11491",
    "data-name": "Group 11491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11490",
    "data-name": "Group 11490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11489",
    "data-name": "Group 11489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11488",
    "data-name": "Group 11488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11487",
    "data-name": "Group 11487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11486",
    "data-name": "Group 11486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11485",
    "data-name": "Group 11485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11484",
    "data-name": "Group 11484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11483",
    "data-name": "Group 11483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11482",
    "data-name": "Group 11482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6618",
    "data-name": "Path 6618",
    d: "M106.856,142.845c-.122.439-1.707.357-3.533.721-1.834.327-3.279.981-3.553.617-.123-.175.105-.6.674-1.057a6.273,6.273,0,0,1,5.4-1.019C106.54,142.328,106.907,142.637,106.856,142.845Z",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11503",
    "data-name": "Group 11503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11502",
    "data-name": "Group 11502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11501",
    "data-name": "Group 11501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11500",
    "data-name": "Group 11500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11499",
    "data-name": "Group 11499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11498",
    "data-name": "Group 11498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11497",
    "data-name": "Group 11497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11496",
    "data-name": "Group 11496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11495",
    "data-name": "Group 11495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11494",
    "data-name": "Group 11494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11493",
    "data-name": "Group 11493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6619",
    "data-name": "Path 6619",
    d: "M121.3,141.984c-.288.381-1.554.106-3.043.2-1.491.051-2.729.451-3.047.1-.142-.172.03-.544.554-.925a4.67,4.67,0,0,1,2.427-.774,4.612,4.612,0,0,1,2.48.53C121.225,141.445,121.426,141.8,121.3,141.984Z",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11504",
    "data-name": "Group 11504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6620",
    "data-name": "Path 6620",
    d: "M84.871,137.141c1.052-1.618,2.941-2.451,4.741-3.145a104.925,104.925,0,0,1,24.137-6.148c1.028,1.694.078,4-1.473,5.233s-3.543,1.72-5.4,2.414-3.758,1.763-4.522,3.591c-.813,1.944-.127,4.246-.841,6.228-1.229,3.412-5.989,4.511-7.2,7.929-.914,2.585.583,5.336.957,8.053A9.8,9.8,0,0,1,85.65,172.45q-.846-14.682-1.694-29.362C83.838,141.05,83.76,138.854,84.871,137.141Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11505",
    "data-name": "Group 11505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6621",
    "data-name": "Path 6621",
    d: "M65.154,161.866c1.546-1.385,3.484-2.583,4.1-4.565.9-2.887-1.422-6.28.072-8.909,1.361-2.4,5.374-2.277,6.639-4.727.989-1.913-.146-3.606.229-5.286s2.761-3.154,4.471-2.953L94.031,154.8c1.241,6.5,2.49,9.957,1.1,13.759a30.829,30.829,0,0,0-2.063,6.318c-.3,2.2.262,4.7,2.062,6-7.992.626-15.481-3.557-22.4-7.6l-7.325-4.28a5.351,5.351,0,0,1-2.013-1.677C62.312,165.538,63.608,163.252,65.154,161.866Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11506",
    "data-name": "Group 11506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6622",
    "data-name": "Path 6622",
    d: "M72.523,171.313a3.8,3.8,0,0,0,.854.164,7.289,7.289,0,0,0,2.489-.177,7.7,7.7,0,0,0,3.472-1.869,7.58,7.58,0,0,0,2.286-4.671,7.813,7.813,0,0,0-.262-3.065,12.464,12.464,0,0,0-1.484-2.97,11.772,11.772,0,0,1-1.531-3.082,3.972,3.972,0,0,1,.428-3.389c.727-.974,2.078-1.212,3.33-1.717a3.652,3.652,0,0,0,1.7-1.262,3.573,3.573,0,0,0,.55-2.1,22.707,22.707,0,0,0-.909-4.162,4.558,4.558,0,0,1-.013-2.042,2.85,2.85,0,0,1,1.154-1.62,7.992,7.992,0,0,1,4.042-1.081,8.656,8.656,0,0,0,4.119-1.211,7.765,7.765,0,0,0,2.819-3.056,12.806,12.806,0,0,0,1.041-3.83,17.867,17.867,0,0,1,.783-3.593,7.991,7.991,0,0,1,1.88-2.833,8.97,8.97,0,0,1,10.478-1.472,10.932,10.932,0,0,1,3.078,2.344,14.458,14.458,0,0,1,1.9,2.727.731.731,0,0,0-.076-.208c-.062-.132-.137-.337-.277-.586a10.481,10.481,0,0,0-1.415-2.054,10.852,10.852,0,0,0-3.093-2.454,9.377,9.377,0,0,0-5.1-1.129,9.533,9.533,0,0,0-5.771,2.553,8.376,8.376,0,0,0-2,2.967,18.153,18.153,0,0,0-.824,3.671,12.44,12.44,0,0,1-1.013,3.7,7.331,7.331,0,0,1-2.663,2.869,8.215,8.215,0,0,1-3.922,1.138,8.388,8.388,0,0,0-4.27,1.163,3.319,3.319,0,0,0-1.332,1.88,4.981,4.981,0,0,0,.008,2.25,23.043,23.043,0,0,1,.907,4.082,3.135,3.135,0,0,1-.466,1.833,3.22,3.22,0,0,1-1.5,1.105c-.6.252-1.239.425-1.858.688a3.8,3.8,0,0,0-1.643,1.181,4.376,4.376,0,0,0-.482,3.753,12.071,12.071,0,0,0,1.6,3.181,12.191,12.191,0,0,1,1.468,2.87,7.5,7.5,0,0,1,.278,2.925,7.337,7.337,0,0,1-2.138,4.52,7.634,7.634,0,0,1-3.337,1.881A8.676,8.676,0,0,1,72.523,171.313Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11507",
    "data-name": "Group 11507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6623",
    "data-name": "Path 6623",
    d: "M61.863,157.541a1.666,1.666,0,0,0-.264.653,2.867,2.867,0,0,0,.343,1.982,3.041,3.041,0,0,0,1.023,1.075,3.187,3.187,0,0,0,1.707.455,3.992,3.992,0,0,0,3.5-2.223,5.334,5.334,0,0,0,.57-2.436,7.437,7.437,0,0,0-.562-2.641c-.634-1.73-1.786-3.415-1.811-5.436a3.691,3.691,0,0,1,.928-2.747,4.036,4.036,0,0,1,2.905-.908,9.792,9.792,0,0,0,3.46-.358,3.008,3.008,0,0,0,1.423-1.2,4.283,4.283,0,0,0,.584-1.763,14.1,14.1,0,0,0-.289-3.553,7.812,7.812,0,0,1,.185-3.293,8.315,8.315,0,0,1,3.72-4.881A11.753,11.753,0,0,1,84.827,129a16.363,16.363,0,0,0,5.058-.8,10.549,10.549,0,0,0,3.581-2.253,10.443,10.443,0,0,0,1.962-2.519,7.573,7.573,0,0,0,.951-2.536,14.624,14.624,0,0,1-1.108,2.446,10.644,10.644,0,0,1-1.982,2.419,10.439,10.439,0,0,1-3.516,2.134,16.28,16.28,0,0,1-4.967.721,12.056,12.056,0,0,0-5.738,1.281,8.722,8.722,0,0,0-3.942,5.128,8.255,8.255,0,0,0-.205,3.477,13.915,13.915,0,0,1,.286,3.437,2.981,2.981,0,0,1-1.722,2.589,9.565,9.565,0,0,1-3.293.33,4.46,4.46,0,0,0-3.209,1.048,4.116,4.116,0,0,0-1.043,3.073,7.85,7.85,0,0,0,.732,2.977c.387.906.819,1.747,1.148,2.588a7.139,7.139,0,0,1,.563,2.505,5.034,5.034,0,0,1-.5,2.284,3.712,3.712,0,0,1-3.212,2.111,2.968,2.968,0,0,1-1.588-.384,2.886,2.886,0,0,1-.98-.977,2.843,2.843,0,0,1-.407-1.874C61.761,157.765,61.887,157.551,61.863,157.541Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11508",
    "data-name": "Group 11508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6624",
    "data-name": "Path 6624",
    d: "M146.09,162.315a3.169,3.169,0,0,1-.027,2.09,2.751,2.751,0,0,1-1.661,1.684,2.887,2.887,0,0,1-2.933-.8,2.654,2.654,0,0,1-.687-1.674,5.52,5.52,0,0,1,.306-2.023c.424-1.353,1.29-2.825,1.157-4.589a6.448,6.448,0,0,0-2.431-4.619,7.546,7.546,0,0,0-2.491-1.311,11.1,11.1,0,0,0-2.846-.41,14.921,14.921,0,0,1-2.763-.288,3.678,3.678,0,0,1-2.151-1.337,4.516,4.516,0,0,1-.777-2.365,8.977,8.977,0,0,1,.207-2.465,18.686,18.686,0,0,0,.716-4.676,7.086,7.086,0,0,0-1.427-3.883,9.131,9.131,0,0,0-2.6-2.2,17.235,17.235,0,0,1-2.082-1.439,5.372,5.372,0,0,1-1.31-1.683c-.007,0,0,.05.034.14a2.318,2.318,0,0,0,.16.392,4.269,4.269,0,0,0,1,1.286,15.854,15.854,0,0,0,2.061,1.522,9.058,9.058,0,0,1,2.483,2.178,6.806,6.806,0,0,1,1.306,3.7,18.737,18.737,0,0,1-.752,4.572,9.41,9.41,0,0,0-.23,2.581,4.951,4.951,0,0,0,.853,2.605,4.132,4.132,0,0,0,2.407,1.516,15.183,15.183,0,0,0,2.852.305,10.733,10.733,0,0,1,2.733.386,7.141,7.141,0,0,1,2.342,1.225,6.033,6.033,0,0,1,2.288,4.29c.141,1.613-.66,3.025-1.1,4.447a5.85,5.85,0,0,0-.3,2.165,3,3,0,0,0,.806,1.873,3.161,3.161,0,0,0,3.258.821,3.047,3.047,0,0,0,1.824-3.5A1.669,1.669,0,0,0,146.09,162.315Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11511",
    "data-name": "Group 11511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6625",
    "data-name": "Path 6625",
    d: "M136.527,240.644V229.577c1.239-6.205.652-13.565-2.234-19.238a105.4,105.4,0,0,0-6.941-10.553L116.335,185.5c-6.058,4.412-15.543,1.224-23.683-1.74,0,0-8.041,4.448-11.781,8.633-3.929,4.4,9.5,59.447,9.5,59.447-6.088,12.179-13.945,22.971-15.137,34.1l63.6,2.451-2.7-29.161Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11514",
    "data-name": "Group 11514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11513",
    "data-name": "Group 11513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6626",
    "data-name": "Path 6626",
    d: "M135.651,259.537a5.7,5.7,0,0,1-.049-1.246c.01-.907.023-2.041.038-3.389.049-2.973.113-6.87.183-11.179.084-4.368.2-8.322.336-11.183.067-1.43.139-2.587.2-3.385a5.73,5.73,0,0,1,.154-1.238,5.754,5.754,0,0,1,.048,1.246c-.01.907-.023,2.041-.038,3.389-.049,2.973-.112,6.871-.183,11.181-.083,4.366-.2,8.32-.336,11.181-.067,1.43-.139,2.587-.2,3.386A5.763,5.763,0,0,1,135.651,259.537Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11516",
    "data-name": "Group 11516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6627",
    "data-name": "Path 6627",
    d: "M164.7,269.6s6.194.336,10.038,2.742,10.006,6.136,12.552,10.773c1.169,2.128-2.163,2.579-3.808,1.342s-4.163-3.562-5.413-3.849l-1.251-.286a83.523,83.523,0,0,0,3.807,7.555c1.3,1.964,2.416,5.321-1.462,5.475,0,0-2.616,3.4-5.257.881,0,0-2.061,3.085-5.381-1.193,0,0-1.932,2.446-2.739,1.514s-3.449-2.423-4.221-5.479a108.679,108.679,0,0,0-4.015-10.491Z",
    fill: "#ffbf9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11523",
    "data-name": "Group 11523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11518",
    "data-name": "Group 11518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6628",
    "data-name": "Path 6628",
    d: "M303.509,183.664c.694.009,29.086-2.981,29.086-2.981s2.4-11.545,2.275-14.545-2.152-22.85-2.152-22.85l10.634-5.03s14.212,47.922,11.105,51.906-8.929,7.544-9.429,7.565-27.507,11.988-46.3,5.769S303.509,183.664,303.509,183.664Z",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11522",
    "data-name": "Group 11522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11519",
    "data-name": "Group 11519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6629",
    "data-name": "Path 6629",
    d: "M278.631,209.532c4.183,4.146,11.383,7.6,23.394,4.6,23.765-5.934,41.571-10.955,48.656-14.8s4.32-20.78,4.916-21.549c1.8-2.317-.174-7.3-2.73-8.076-7.266-2.2-19.922-1.334-20.555-.67-3.734,3.916-.328,8.68-.328,8.68l-31.334,4.1a52.13,52.13,0,0,0-11.51.737",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11521",
    "data-name": "Group 11521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11520",
    "data-name": "Group 11520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6630",
    "data-name": "Path 6630",
    d: "M289.14,182.553s.253-.066.752-.161,1.242-.221,2.219-.344a51.229,51.229,0,0,1,8.548-.359h-.025l31.321-4.2-.151.348a8.34,8.34,0,0,1-1.443-5.147,5.886,5.886,0,0,1,.9-2.661,7.811,7.811,0,0,1,.864-1.141,1.487,1.487,0,0,1,.408-.219l.357-.09c.24-.063.471-.084.707-.128a61.7,61.7,0,0,1,11.685-.246,40.7,40.7,0,0,1,6.078.838c.507.116,1.01.262,1.518.393a3.821,3.821,0,0,1,1.434.835A7.08,7.08,0,0,1,356.075,173a6.792,6.792,0,0,1,.414,3.259,3.823,3.823,0,0,1-.629,1.592c-.093.1-.081.372-.094.632l.009.8c.075,2.149.174,4.339.118,6.546a27.911,27.911,0,0,1-1.49,9.222,9.038,9.038,0,0,1-2.605,3.827,9.194,9.194,0,0,1-1.975,1.177c-.666.353-1.361.626-2.036.94-2.733,1.173-5.487,2.127-8.193,3.025s-5.376,1.71-7.987,2.475c-10.452,3.043-19.958,5.428-27.941,7.417a54.493,54.493,0,0,1-5.76,1.2,31.133,31.133,0,0,1-5.246.279,21.994,21.994,0,0,1-8.185-1.777,18.965,18.965,0,0,1-4.5-2.8,11.567,11.567,0,0,1-1.343-1.271c.025-.027.461.441,1.41,1.19a19.678,19.678,0,0,0,4.514,2.7,22.018,22.018,0,0,0,8.114,1.672,31.206,31.206,0,0,0,5.191-.316,54.613,54.613,0,0,0,5.717-1.226c7.969-2.035,17.463-4.456,27.894-7.52,2.606-.77,5.269-1.588,7.966-2.487s5.441-1.855,8.148-3.021c.666-.312,1.358-.583,2.01-.931a8.7,8.7,0,0,0,1.877-1.117,8.544,8.544,0,0,0,2.449-3.617,27.5,27.5,0,0,0,1.452-9.046c.055-2.188-.042-4.355-.117-6.519l-.009-.819c0-.139.009-.279.021-.426a1.662,1.662,0,0,1,.044-.249,1.123,1.123,0,0,1,.078-.173l.049-.08a3.325,3.325,0,0,0,.539-1.368,6.3,6.3,0,0,0-.386-3,6.578,6.578,0,0,0-1.626-2.52,3.325,3.325,0,0,0-1.238-.727c-.5-.128-.987-.271-1.484-.386a40.371,40.371,0,0,0-6-.835,61.727,61.727,0,0,0-11.577.217c-.223.042-.461.064-.672.12l-.321.078a1.514,1.514,0,0,0-.208.094,7.2,7.2,0,0,0-.808,1.061,5.416,5.416,0,0,0-.837,2.457,7.912,7.912,0,0,0,1.344,4.848l.2.3-.348.044-31.345,4.011h-.025a54.466,54.466,0,0,0-8.516.237c-.977.1-1.722.205-2.223.279S289.14,182.553,289.14,182.553Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11541",
    "data-name": "Group 11541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11524",
    "data-name": "Group 11524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_514",
    "data-name": "Rectangle 514",
    d: "M0,0H26.2a0,0,0,0,1,0,0V276.239a11.973,11.973,0,0,1-11.973,11.973h-2.25A11.973,11.973,0,0,1,0,276.239V0A0,0,0,0,1,0,0Z",
    transform: "matrix(-0.486, -0.874, 0.874, -0.486, 204.312, 215.123)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11525",
    "data-name": "Group 11525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_515",
    "data-name": "Rectangle 515",
    d: "M0,0H60.771a2.237,2.237,0,0,1,2.237,2.237V17.761A2.237,2.237,0,0,1,60.771,20H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(406.703 93.867) rotate(-119.102)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11526",
    "data-name": "Group 11526"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_516",
    "data-name": "Rectangle 516",
    width: 50.766,
    height: 19.997,
    rx: 3.244,
    transform: "matrix(-0.486, -0.874, 0.874, -0.486, 371.674, 110.67)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11527",
    "data-name": "Group 11527"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_517",
    "data-name": "Rectangle 517",
    width: 27.417,
    height: 31.057,
    transform: "translate(380.917 90.838) rotate(-119.102)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11529",
    "data-name": "Group 11529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11528",
    "data-name": "Group 11528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6631",
    "data-name": "Path 6631",
    d: "M429.391,59.858c.07.125-47.3,26.625-105.785,59.18C265.1,151.6,217.628,177.9,217.558,177.77s47.287-26.62,105.795-59.187C381.84,86.028,429.321,59.732,429.391,59.858Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11530",
    "data-name": "Group 11530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6632",
    "data-name": "Path 6632",
    d: "M106.564,259.41c17.792,31.964,55.325,45.013,83.831,29.146s37.192-54.643,19.4-86.607S154.47,156.935,125.964,172.8,88.772,227.445,106.564,259.41Zm87.784-48.863c12.467,22.4,6.381,49.569-13.594,60.688s-46.275,1.975-58.743-20.424-6.381-49.569,13.594-60.687S181.88,188.149,194.348,210.547Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11531",
    "data-name": "Group 11531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_518",
    "data-name": "Rectangle 518",
    d: "M6.517,0H33.6a6.517,6.517,0,0,1,6.517,6.517V7.742A6.517,6.517,0,0,1,33.6,14.26H6.518A6.518,6.518,0,0,1,0,7.742V6.517A6.517,6.517,0,0,1,6.517,0Z",
    transform: "translate(248.517 198.655) rotate(-119.102)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11532",
    "data-name": "Group 11532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    d: "M6.517,0H33.6a6.518,6.518,0,0,1,6.518,6.518V7.742A6.517,6.517,0,0,1,33.6,14.26H6.517A6.517,6.517,0,0,1,0,7.743V6.517A6.517,6.517,0,0,1,6.517,0Z",
    transform: "translate(273.814 184.575) rotate(-119.102)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11534",
    "data-name": "Group 11534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11533",
    "data-name": "Group 11533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6633",
    "data-name": "Path 6633",
    d: "M244.36,161.952c.126-.068,3.184,5.3,6.829,11.986s6.5,12.166,6.372,12.235-3.183-5.3-6.829-11.986S244.233,162.021,244.36,161.952Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11536",
    "data-name": "Group 11536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11535",
    "data-name": "Group 11535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6634",
    "data-name": "Path 6634",
    d: "M232.752,170.254c.126-.07,3.11,5.052,6.665,11.438s6.337,11.623,6.211,11.693-3.109-5.051-6.666-11.439S232.627,170.324,232.752,170.254Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11538",
    "data-name": "Group 11538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11537",
    "data-name": "Group 11537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6635",
    "data-name": "Path 6635",
    d: "M269.812,148.066c.126-.07,3.235,5.276,6.943,11.938s6.615,12.123,6.489,12.193-3.234-5.275-6.944-11.94S269.686,148.136,269.812,148.066Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11540",
    "data-name": "Group 11540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11539",
    "data-name": "Group 11539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6636",
    "data-name": "Path 6636",
    d: "M257.6,155.441c.126-.069,3.169,5.241,6.8,11.86s6.466,12.042,6.34,12.112-3.169-5.241-6.8-11.862S257.471,155.51,257.6,155.441Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12010",
    "data-name": "Group 12010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11998",
    "data-name": "Group 11998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11722",
    "data-name": "Group 11722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11705",
    "data-name": "Group 11705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11704",
    "data-name": "Group 11704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11549",
    "data-name": "Group 11549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11548",
    "data-name": "Group 11548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11547",
    "data-name": "Group 11547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11546",
    "data-name": "Group 11546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11545",
    "data-name": "Group 11545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11544",
    "data-name": "Group 11544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11543",
    "data-name": "Group 11543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11542",
    "data-name": "Group 11542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6637",
    "data-name": "Path 6637",
    d: "M330.131,119.372a4.727,4.727,0,0,0,2.019-9.186,4.917,4.917,0,0,0-4.271-8.3,5.884,5.884,0,0,0-8.864-4.838,6.616,6.616,0,0,0-8.146-.18,4.706,4.706,0,0,0-4.169,7.976",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11703",
    "data-name": "Group 11703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11685",
    "data-name": "Group 11685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11554",
    "data-name": "Group 11554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11553",
    "data-name": "Group 11553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11552",
    "data-name": "Group 11552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11551",
    "data-name": "Group 11551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11550",
    "data-name": "Group 11550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6638",
    "data-name": "Path 6638",
    d: "M309.844,101.532l1.038,0a20.052,20.052,0,0,1,19.934,18.5c.752,9.691,1.458,20.407,1.378,25.605-.165,10.762-10.935,12.4-10.935,12.4l.872,12.933-26.118-.889-2.168-46.9C292.915,112.01,298.645,102.152,309.844,101.532Z",
    fill: "#ffbf9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11565",
    "data-name": "Group 11565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11564",
    "data-name": "Group 11564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11563",
    "data-name": "Group 11563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11562",
    "data-name": "Group 11562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11561",
    "data-name": "Group 11561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11560",
    "data-name": "Group 11560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11559",
    "data-name": "Group 11559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11558",
    "data-name": "Group 11558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11557",
    "data-name": "Group 11557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11556",
    "data-name": "Group 11556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11555",
    "data-name": "Group 11555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6639",
    "data-name": "Path 6639",
    d: "M321.349,158.029a26.115,26.115,0,0,1-14.09-4.17s3.462,8.147,14.2,7.21Z",
    fill: "#ff9a6c"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11579",
    "data-name": "Group 11579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11578",
    "data-name": "Group 11578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11577",
    "data-name": "Group 11577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11576",
    "data-name": "Group 11576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11575",
    "data-name": "Group 11575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11574",
    "data-name": "Group 11574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11573",
    "data-name": "Group 11573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11572",
    "data-name": "Group 11572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11571",
    "data-name": "Group 11571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11570",
    "data-name": "Group 11570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11569",
    "data-name": "Group 11569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11568",
    "data-name": "Group 11568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11567",
    "data-name": "Group 11567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11566",
    "data-name": "Group 11566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6640",
    "data-name": "Path 6640",
    d: "M324.909,130.145a1.537,1.537,0,0,1-1.487,1.546,1.469,1.469,0,0,1-1.58-1.39,1.537,1.537,0,0,1,1.485-1.547A1.472,1.472,0,0,1,324.909,130.145Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11594",
    "data-name": "Group 11594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11593",
    "data-name": "Group 11593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11592",
    "data-name": "Group 11592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11591",
    "data-name": "Group 11591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11590",
    "data-name": "Group 11590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11589",
    "data-name": "Group 11589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11588",
    "data-name": "Group 11588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11587",
    "data-name": "Group 11587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11586",
    "data-name": "Group 11586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11585",
    "data-name": "Group 11585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11584",
    "data-name": "Group 11584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11583",
    "data-name": "Group 11583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11582",
    "data-name": "Group 11582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11581",
    "data-name": "Group 11581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11580",
    "data-name": "Group 11580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6641",
    "data-name": "Path 6641",
    d: "M328.486,125.295c-.191.2-1.352-.666-3.006-.666-1.652-.025-2.869.823-3.047.62-.088-.091.107-.452.636-.835a4.227,4.227,0,0,1,2.441-.744,4.055,4.055,0,0,1,2.392.78C328.41,124.842,328.581,125.205,328.486,125.295Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11608",
    "data-name": "Group 11608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11607",
    "data-name": "Group 11607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11606",
    "data-name": "Group 11606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11605",
    "data-name": "Group 11605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11604",
    "data-name": "Group 11604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11603",
    "data-name": "Group 11603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11602",
    "data-name": "Group 11602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11601",
    "data-name": "Group 11601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11600",
    "data-name": "Group 11600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11599",
    "data-name": "Group 11599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11598",
    "data-name": "Group 11598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11597",
    "data-name": "Group 11597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11596",
    "data-name": "Group 11596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11595",
    "data-name": "Group 11595"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6642",
    "data-name": "Path 6642",
    d: "M309.987,129.433a1.536,1.536,0,0,1-1.486,1.546,1.47,1.47,0,0,1-1.58-1.391,1.538,1.538,0,0,1,1.485-1.547A1.471,1.471,0,0,1,309.987,129.433Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11623",
    "data-name": "Group 11623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11622",
    "data-name": "Group 11622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11621",
    "data-name": "Group 11621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11620",
    "data-name": "Group 11620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11619",
    "data-name": "Group 11619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11618",
    "data-name": "Group 11618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11617",
    "data-name": "Group 11617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11616",
    "data-name": "Group 11616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11615",
    "data-name": "Group 11615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11614",
    "data-name": "Group 11614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11613",
    "data-name": "Group 11613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11612",
    "data-name": "Group 11612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11611",
    "data-name": "Group 11611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11610",
    "data-name": "Group 11610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11609",
    "data-name": "Group 11609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6643",
    "data-name": "Path 6643",
    d: "M312.229,125.554c-.192.2-1.355-.665-3.007-.666-1.652-.024-2.869.823-3.047.62-.088-.09.105-.451.637-.834a4.214,4.214,0,0,1,2.44-.745,4.048,4.048,0,0,1,2.392.781C312.15,125.1,312.322,125.465,312.229,125.554Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11637",
    "data-name": "Group 11637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11636",
    "data-name": "Group 11636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11635",
    "data-name": "Group 11635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11634",
    "data-name": "Group 11634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11633",
    "data-name": "Group 11633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11632",
    "data-name": "Group 11632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11631",
    "data-name": "Group 11631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11630",
    "data-name": "Group 11630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11629",
    "data-name": "Group 11629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11628",
    "data-name": "Group 11628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11627",
    "data-name": "Group 11627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11626",
    "data-name": "Group 11626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11625",
    "data-name": "Group 11625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11624",
    "data-name": "Group 11624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6644",
    "data-name": "Path 6644",
    d: "M318.194,137.838a10.866,10.866,0,0,1,2.687-.477c.423-.042.823-.125.895-.413a2.155,2.155,0,0,0-.278-1.253q-.591-1.535-1.239-3.22c-1.721-4.583-2.965-8.352-2.78-8.42s1.73,3.593,3.451,8.177c.414,1.131.81,2.208,1.186,3.239a2.437,2.437,0,0,1,.214,1.658,1.055,1.055,0,0,1-.7.615,2.859,2.859,0,0,1-.717.1A10.848,10.848,0,0,1,318.194,137.838Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11647",
    "data-name": "Group 11647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11646",
    "data-name": "Group 11646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11645",
    "data-name": "Group 11645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11644",
    "data-name": "Group 11644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11643",
    "data-name": "Group 11643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11642",
    "data-name": "Group 11642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11641",
    "data-name": "Group 11641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11640",
    "data-name": "Group 11640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11639",
    "data-name": "Group 11639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11638",
    "data-name": "Group 11638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6645",
    "data-name": "Path 6645",
    d: "M313.683,119.195c-.22.419-1.636-.04-3.381-.1-1.743-.1-3.215.223-3.373-.213-.068-.208.243-.583.873-.917a5.236,5.236,0,0,1,2.62-.543,5.054,5.054,0,0,1,2.525.783C313.525,118.593,313.78,119,313.683,119.195Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11657",
    "data-name": "Group 11657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11656",
    "data-name": "Group 11656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11655",
    "data-name": "Group 11655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11654",
    "data-name": "Group 11654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11653",
    "data-name": "Group 11653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11652",
    "data-name": "Group 11652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11651",
    "data-name": "Group 11651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11650",
    "data-name": "Group 11650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11649",
    "data-name": "Group 11649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11648",
    "data-name": "Group 11648"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6646",
    "data-name": "Path 6646",
    d: "M328.587,118.475c-.349.375-1.713-.019-3.355-.043-1.64-.071-3.032.244-3.35-.15-.14-.191.08-.567.688-.921a5.349,5.349,0,0,1,2.73-.607,5.257,5.257,0,0,1,2.674.763C328.552,117.9,328.742,118.293,328.587,118.475Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11666",
    "data-name": "Group 11666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11665",
    "data-name": "Group 11665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11664",
    "data-name": "Group 11664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11663",
    "data-name": "Group 11663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11662",
    "data-name": "Group 11662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11661",
    "data-name": "Group 11661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11660",
    "data-name": "Group 11660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11659",
    "data-name": "Group 11659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11658",
    "data-name": "Group 11658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6647",
    "data-name": "Path 6647",
    d: "M329.8,115.1s-2.818-6.748-6.063-8.331c-3.929-1.915-5.636,2.4-9.382,1.338s-7.5-2.9-11.337-.011c-4.2,3.16-2.246,5.392-2.519,10.166-1.109,19.357-4.662,24.821-5.64,15.7-.107-1-2.877-1.8-3.275-6.024-.516-5.475-.707-12.122.527-16,1.039-3.271,2.913-5.527,6.268-8.011,5.3-3.92,12.554-3.983,17.482-3.472S330.27,106.66,329.8,115.1Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11675",
    "data-name": "Group 11675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11674",
    "data-name": "Group 11674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11673",
    "data-name": "Group 11673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11672",
    "data-name": "Group 11672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11671",
    "data-name": "Group 11671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11670",
    "data-name": "Group 11670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11669",
    "data-name": "Group 11669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11668",
    "data-name": "Group 11668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11667",
    "data-name": "Group 11667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6648",
    "data-name": "Path 6648",
    d: "M295.542,133.668a2.92,2.92,0,0,0-3.145-2.825c-2.008.184-4.245,1.317-4.125,5.465.213,7.359,7.556,5.628,7.563,5.416C295.839,141.581,295.659,136.746,295.542,133.668Z",
    fill: "#ffbf9d"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11684",
    "data-name": "Group 11684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11683",
    "data-name": "Group 11683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11682",
    "data-name": "Group 11682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11681",
    "data-name": "Group 11681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11680",
    "data-name": "Group 11680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11679",
    "data-name": "Group 11679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11678",
    "data-name": "Group 11678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11677",
    "data-name": "Group 11677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11676",
    "data-name": "Group 11676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6649",
    "data-name": "Path 6649",
    d: "M294.154,139c-.033-.023-.126.093-.34.2a1.277,1.277,0,0,1-.957.047,3.171,3.171,0,0,1-1.55-2.8,4.239,4.239,0,0,1,.306-1.846,1.477,1.477,0,0,1,.935-1.011.653.653,0,0,1,.767.329c.105.2.062.351.1.363.021.018.154-.128.086-.43a.817.817,0,0,0-.3-.453.973.973,0,0,0-.714-.167,1.8,1.8,0,0,0-1.306,1.18,4.35,4.35,0,0,0-.385,2.063c.09,1.482.889,2.848,1.961,3.124a1.374,1.374,0,0,0,1.167-.228C294.146,139.18,294.18,139.014,294.154,139Z",
    fill: "#ff9a6c"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11693",
    "data-name": "Group 11693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11692",
    "data-name": "Group 11692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11691",
    "data-name": "Group 11691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11690",
    "data-name": "Group 11690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11689",
    "data-name": "Group 11689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11688",
    "data-name": "Group 11688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11687",
    "data-name": "Group 11687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11686",
    "data-name": "Group 11686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6650",
    "data-name": "Path 6650",
    d: "M295.729,119.412a7,7,0,0,0,3.112,1.449,2.4,2.4,0,0,0,2.668-1.68c.089-.512-.035-1.107.3-1.5.4-.471,1.144-.32,1.761-.253,2.138.233,4.645-2.122,5.2-4.2a1.919,1.919,0,0,0,2.564.539,6.873,6.873,0,0,0,1.778-1.571,3.023,3.023,0,0,1,2.529-1.255,7.312,7.312,0,0,0,1.6.357c.966-.083,1.441-1.213,1.591-2.172s.266-2.077,1.086-2.6c.759-.481,1.741-.2,2.631-.065s2.038-.072,2.268-.941a1.744,1.744,0,0,0-.325-1.335,4.767,4.767,0,0,0-5.62-1.822,6.458,6.458,0,0,0-11.863-1.287,6.554,6.554,0,0,0-10.485,2.358,4.751,4.751,0,0,0-5.378,6.9,4.511,4.511,0,0,0-2.493,3.585c-.032,1.523,1.446,3.045,2.918,2.649a2.631,2.631,0,0,0,4.542,2.638",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11702",
    "data-name": "Group 11702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11701",
    "data-name": "Group 11701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11700",
    "data-name": "Group 11700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11699",
    "data-name": "Group 11699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11698",
    "data-name": "Group 11698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11697",
    "data-name": "Group 11697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11696",
    "data-name": "Group 11696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11695",
    "data-name": "Group 11695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11694",
    "data-name": "Group 11694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6651",
    "data-name": "Path 6651",
    d: "M319.411,104.532a.369.369,0,0,1,0,.135c-.01.088-.015.222-.048.393a4.629,4.629,0,0,1-.538,1.416,5.262,5.262,0,0,1-1.637,1.734,4.9,4.9,0,0,1-3.017.851l.125-.163a2.664,2.664,0,0,1-.153,2.031,7.647,7.647,0,0,1-1.265,1.806,5.488,5.488,0,0,1-.826.842,2.576,2.576,0,0,1-1.167.429,2.688,2.688,0,0,1-2.366-.856l.275-.078a5.518,5.518,0,0,1-2.352,3.811,4.024,4.024,0,0,1-2.419.785,7.259,7.259,0,0,1-2.379-.53l.2-.086a5.794,5.794,0,0,1-1.748,2.266,3.088,3.088,0,0,1-2.566.69,4.052,4.052,0,0,1-3.111-3.181l.166.078a3.8,3.8,0,0,1-2.529.364,4.114,4.114,0,0,1-1.761-.792,3.554,3.554,0,0,1-.819-.9,1.766,1.766,0,0,1-.186-.381,4.414,4.414,0,0,0,1.08,1.184,4.074,4.074,0,0,0,1.717.715,3.636,3.636,0,0,0,2.388-.384l.138-.078.028.156a3.824,3.824,0,0,0,2.944,2.948,2.8,2.8,0,0,0,2.329-.653,5.536,5.536,0,0,0,1.643-2.15l.058-.136.139.049a7.006,7.006,0,0,0,2.276.5,3.713,3.713,0,0,0,2.233-.73,5.225,5.225,0,0,0,2.225-3.592l.047-.348.228.271a2.391,2.391,0,0,0,2.089.755,2.28,2.28,0,0,0,1.035-.372,5.342,5.342,0,0,0,.779-.789,7.443,7.443,0,0,0,1.236-1.728,2.416,2.416,0,0,0,.166-1.838L314,108.8l.185.013a4.724,4.724,0,0,0,2.89-.77A5.244,5.244,0,0,0,318.7,106.4,5.681,5.681,0,0,0,319.411,104.532Z",
    fill: "#455a64"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11721",
    "data-name": "Group 11721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11720",
    "data-name": "Group 11720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11719",
    "data-name": "Group 11719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11718",
    "data-name": "Group 11718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11717",
    "data-name": "Group 11717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11716",
    "data-name": "Group 11716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11715",
    "data-name": "Group 11715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11714",
    "data-name": "Group 11714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11713",
    "data-name": "Group 11713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11712",
    "data-name": "Group 11712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11711",
    "data-name": "Group 11711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11710",
    "data-name": "Group 11710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11709",
    "data-name": "Group 11709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11708",
    "data-name": "Group 11708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11707",
    "data-name": "Group 11707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11706",
    "data-name": "Group 11706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6652",
    "data-name": "Path 6652",
    d: "M318.165,143.333c-.051-.273-1.846.17-3.5-1.049s-1.933-3.179-2.187-3.131c-.119,0-.243.513-.065,1.326a4.6,4.6,0,0,0,1.725,2.638,4.01,4.01,0,0,0,2.908.765C317.811,143.764,318.206,143.453,318.165,143.333Z",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11997",
    "data-name": "Group 11997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11855",
    "data-name": "Group 11855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11854",
    "data-name": "Group 11854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11740",
    "data-name": "Group 11740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11739",
    "data-name": "Group 11739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11738",
    "data-name": "Group 11738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11737",
    "data-name": "Group 11737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11736",
    "data-name": "Group 11736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11735",
    "data-name": "Group 11735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11734",
    "data-name": "Group 11734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11733",
    "data-name": "Group 11733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11732",
    "data-name": "Group 11732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11731",
    "data-name": "Group 11731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11730",
    "data-name": "Group 11730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11729",
    "data-name": "Group 11729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11728",
    "data-name": "Group 11728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11727",
    "data-name": "Group 11727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11726",
    "data-name": "Group 11726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11725",
    "data-name": "Group 11725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11724",
    "data-name": "Group 11724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11723",
    "data-name": "Group 11723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6653",
    "data-name": "Path 6653",
    d: "M373.626,423.115l7.1,24.2s26.978.9,28.726,5.247l-46.416,15.46-12.617-37.243Z",
    fill: "#455a64"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11759",
    "data-name": "Group 11759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11758",
    "data-name": "Group 11758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11757",
    "data-name": "Group 11757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11756",
    "data-name": "Group 11756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11755",
    "data-name": "Group 11755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11754",
    "data-name": "Group 11754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11753",
    "data-name": "Group 11753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11752",
    "data-name": "Group 11752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11751",
    "data-name": "Group 11751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11750",
    "data-name": "Group 11750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11749",
    "data-name": "Group 11749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11748",
    "data-name": "Group 11748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11747",
    "data-name": "Group 11747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11746",
    "data-name": "Group 11746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11745",
    "data-name": "Group 11745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11744",
    "data-name": "Group 11744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11743",
    "data-name": "Group 11743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11742",
    "data-name": "Group 11742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11741",
    "data-name": "Group 11741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6654",
    "data-name": "Path 6654",
    d: "M365.708,450.079a2,2,0,0,0-.59,2.6,1.92,1.92,0,0,0,2.572.607,2.108,2.108,0,0,0,.61-2.756,1.992,1.992,0,0,0-2.745-.335",
    fill: "#e0e0e0"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11777",
    "data-name": "Group 11777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11776",
    "data-name": "Group 11776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11775",
    "data-name": "Group 11775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11774",
    "data-name": "Group 11774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11773",
    "data-name": "Group 11773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11772",
    "data-name": "Group 11772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11771",
    "data-name": "Group 11771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11770",
    "data-name": "Group 11770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11769",
    "data-name": "Group 11769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11768",
    "data-name": "Group 11768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11767",
    "data-name": "Group 11767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11766",
    "data-name": "Group 11766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11765",
    "data-name": "Group 11765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11764",
    "data-name": "Group 11764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11763",
    "data-name": "Group 11763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11762",
    "data-name": "Group 11762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11761",
    "data-name": "Group 11761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11760",
    "data-name": "Group 11760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6655",
    "data-name": "Path 6655",
    d: "M406.84,450.813s2.366.211,2.617,1.744l-46.416,15.46-1.125-3.8,44.924-13.4",
    fill: "#263238"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11796",
    "data-name": "Group 11796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11795",
    "data-name": "Group 11795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11794",
    "data-name": "Group 11794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11793",
    "data-name": "Group 11793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11792",
    "data-name": "Group 11792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11791",
    "data-name": "Group 11791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11790",
    "data-name": "Group 11790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11789",
    "data-name": "Group 11789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11788",
    "data-name": "Group 11788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11787",
    "data-name": "Group 11787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11786",
    "data-name": "Group 11786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11785",
    "data-name": "Group 11785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11784",
    "data-name": "Group 11784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11783",
    "data-name": "Group 11783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11782",
    "data-name": "Group 11782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11781",
    "data-name": "Group 11781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11780",
    "data-name": "Group 11780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11779",
    "data-name": "Group 11779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11778",
    "data-name": "Group 11778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6656",
    "data-name": "Path 6656",
    d: "M381.4,446.823c.068.229-1.031.709-1.9,1.809-.9,1.078-1.149,2.251-1.388,2.231-.224.026-.337-1.442.743-2.756S381.384,446.6,381.4,446.823Z",
    fill: "#fff"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11815",
    "data-name": "Group 11815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11814",
    "data-name": "Group 11814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11813",
    "data-name": "Group 11813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11812",
    "data-name": "Group 11812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11811",
    "data-name": "Group 11811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11810",
    "data-name": "Group 11810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11809",
    "data-name": "Group 11809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11808",
    "data-name": "Group 11808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11807",
    "data-name": "Group 11807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11806",
    "data-name": "Group 11806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11805",
    "data-name": "Group 11805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11804",
    "data-name": "Group 11804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11803",
    "data-name": "Group 11803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11802",
    "data-name": "Group 11802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11801",
    "data-name": "Group 11801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11800",
    "data-name": "Group 11800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11799",
    "data-name": "Group 11799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11798",
    "data-name": "Group 11798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11797",
    "data-name": "Group 11797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6657",
    "data-name": "Path 6657",
    d: "M386.943,447.215c.125.2-.728.915-1.179,2.13-.486,1.2-.335,2.3-.564,2.368-.2.107-.8-1.169-.211-2.669S386.866,447,386.943,447.215Z",
    fill: "#fff"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11834",
    "data-name": "Group 11834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11833",
    "data-name": "Group 11833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11832",
    "data-name": "Group 11832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11831",
    "data-name": "Group 11831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11830",
    "data-name": "Group 11830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11829",
    "data-name": "Group 11829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11828",
    "data-name": "Group 11828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11827",
    "data-name": "Group 11827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11826",
    "data-name": "Group 11826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11825",
    "data-name": "Group 11825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11824",
    "data-name": "Group 11824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11823",
    "data-name": "Group 11823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11822",
    "data-name": "Group 11822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11821",
    "data-name": "Group 11821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11820",
    "data-name": "Group 11820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11819",
    "data-name": "Group 11819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11818",
    "data-name": "Group 11818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11817",
    "data-name": "Group 11817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11816",
    "data-name": "Group 11816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6658",
    "data-name": "Path 6658",
    d: "M391.649,452.121c-.19.116-.882-.911-.714-2.346s1.064-2.282,1.223-2.125c.19.144-.276,1.039-.4,2.219C391.613,451.046,391.867,452.023,391.649,452.121Z",
    fill: "#fff"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11853",
    "data-name": "Group 11853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11852",
    "data-name": "Group 11852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11851",
    "data-name": "Group 11851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11850",
    "data-name": "Group 11850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11849",
    "data-name": "Group 11849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11848",
    "data-name": "Group 11848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11847",
    "data-name": "Group 11847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11846",
    "data-name": "Group 11846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11845",
    "data-name": "Group 11845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11844",
    "data-name": "Group 11844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11843",
    "data-name": "Group 11843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11842",
    "data-name": "Group 11842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11841",
    "data-name": "Group 11841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11840",
    "data-name": "Group 11840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11839",
    "data-name": "Group 11839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11838",
    "data-name": "Group 11838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11837",
    "data-name": "Group 11837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11836",
    "data-name": "Group 11836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11835",
    "data-name": "Group 11835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6659",
    "data-name": "Path 6659",
    d: "M379.173,441.488c-.026.239-1.17.272-2.422.787-1.262.488-2.116,1.249-2.3,1.1-.186-.121.508-1.284,1.991-1.868S379.225,441.274,379.173,441.488Z",
    fill: "#fff"
  })))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11988",
    "data-name": "Group 11988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11987",
    "data-name": "Group 11987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11873",
    "data-name": "Group 11873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11872",
    "data-name": "Group 11872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11871",
    "data-name": "Group 11871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11870",
    "data-name": "Group 11870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11869",
    "data-name": "Group 11869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11868",
    "data-name": "Group 11868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11867",
    "data-name": "Group 11867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11866",
    "data-name": "Group 11866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11865",
    "data-name": "Group 11865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11864",
    "data-name": "Group 11864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11863",
    "data-name": "Group 11863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11862",
    "data-name": "Group 11862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11861",
    "data-name": "Group 11861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11860",
    "data-name": "Group 11860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11859",
    "data-name": "Group 11859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11858",
    "data-name": "Group 11858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11857",
    "data-name": "Group 11857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11856",
    "data-name": "Group 11856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6660",
    "data-name": "Path 6660",
    d: "M265.29,423.328l-10.106,23.1s20.087,18.032,18.635,22.483l-45.5-17.988,14.271-36.641Z",
    fill: "#455a64"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11892",
    "data-name": "Group 11892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11891",
    "data-name": "Group 11891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11890",
    "data-name": "Group 11890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11889",
    "data-name": "Group 11889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11888",
    "data-name": "Group 11888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11887",
    "data-name": "Group 11887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11886",
    "data-name": "Group 11886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11885",
    "data-name": "Group 11885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11884",
    "data-name": "Group 11884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11883",
    "data-name": "Group 11883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11882",
    "data-name": "Group 11882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11881",
    "data-name": "Group 11881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11880",
    "data-name": "Group 11880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11879",
    "data-name": "Group 11879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11878",
    "data-name": "Group 11878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11877",
    "data-name": "Group 11877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11876",
    "data-name": "Group 11876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11875",
    "data-name": "Group 11875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11874",
    "data-name": "Group 11874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6661",
    "data-name": "Path 6661",
    d: "M241.9,438.9a2,2,0,0,0-2.123,1.612,1.92,1.92,0,0,0,1.58,2.118,2.107,2.107,0,0,0,2.239-1.719c.038-.981-.913-2.134-1.888-2.021",
    fill: "#e0e0e0"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11910",
    "data-name": "Group 11910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11909",
    "data-name": "Group 11909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11908",
    "data-name": "Group 11908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11907",
    "data-name": "Group 11907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11906",
    "data-name": "Group 11906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11905",
    "data-name": "Group 11905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11904",
    "data-name": "Group 11904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11903",
    "data-name": "Group 11903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11902",
    "data-name": "Group 11902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11901",
    "data-name": "Group 11901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11900",
    "data-name": "Group 11900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11899",
    "data-name": "Group 11899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11898",
    "data-name": "Group 11898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11897",
    "data-name": "Group 11897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11896",
    "data-name": "Group 11896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11895",
    "data-name": "Group 11895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11894",
    "data-name": "Group 11894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11893",
    "data-name": "Group 11893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6662",
    "data-name": "Path 6662",
    d: "M272.935,465.894s1.676,1.682.884,3.018l-45.5-17.988,1.583-3.637,43.03,18.607",
    fill: "#263238"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11929",
    "data-name": "Group 11929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11928",
    "data-name": "Group 11928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11927",
    "data-name": "Group 11927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11926",
    "data-name": "Group 11926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11925",
    "data-name": "Group 11925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11924",
    "data-name": "Group 11924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11923",
    "data-name": "Group 11923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11922",
    "data-name": "Group 11922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11921",
    "data-name": "Group 11921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11920",
    "data-name": "Group 11920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11919",
    "data-name": "Group 11919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11918",
    "data-name": "Group 11918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11917",
    "data-name": "Group 11917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11916",
    "data-name": "Group 11916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11915",
    "data-name": "Group 11915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11914",
    "data-name": "Group 11914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11913",
    "data-name": "Group 11913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11912",
    "data-name": "Group 11912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11911",
    "data-name": "Group 11911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6663",
    "data-name": "Path 6663",
    d: "M256.012,446.489c-.095.22-1.245-.119-2.621.163-1.383.246-2.327.986-2.5.817-.188-.124.668-1.321,2.34-1.633C254.9,445.508,256.141,446.3,256.012,446.489Z",
    fill: "#fff"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11948",
    "data-name": "Group 11948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11947",
    "data-name": "Group 11947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11946",
    "data-name": "Group 11946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11945",
    "data-name": "Group 11945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11944",
    "data-name": "Group 11944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11943",
    "data-name": "Group 11943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11942",
    "data-name": "Group 11942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11941",
    "data-name": "Group 11941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11940",
    "data-name": "Group 11940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11939",
    "data-name": "Group 11939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11938",
    "data-name": "Group 11938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11937",
    "data-name": "Group 11937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11936",
    "data-name": "Group 11936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11935",
    "data-name": "Group 11935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11934",
    "data-name": "Group 11934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11933",
    "data-name": "Group 11933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11932",
    "data-name": "Group 11932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11931",
    "data-name": "Group 11931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11930",
    "data-name": "Group 11930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6664",
    "data-name": "Path 6664",
    d: "M260,450.35c-.034.235-1.146.232-2.272.874-1.145.608-1.737,1.549-1.954,1.451-.223-.047.138-1.409,1.553-2.18S260.083,450.136,260,450.35Z",
    fill: "#fff"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11967",
    "data-name": "Group 11967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11966",
    "data-name": "Group 11966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11965",
    "data-name": "Group 11965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11964",
    "data-name": "Group 11964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11963",
    "data-name": "Group 11963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11962",
    "data-name": "Group 11962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11961",
    "data-name": "Group 11961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11960",
    "data-name": "Group 11960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11959",
    "data-name": "Group 11959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11958",
    "data-name": "Group 11958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11957",
    "data-name": "Group 11957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11956",
    "data-name": "Group 11956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11955",
    "data-name": "Group 11955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11954",
    "data-name": "Group 11954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11953",
    "data-name": "Group 11953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11952",
    "data-name": "Group 11952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11951",
    "data-name": "Group 11951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11950",
    "data-name": "Group 11950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11949",
    "data-name": "Group 11949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6665",
    "data-name": "Path 6665",
    d: "M260.456,457.132c-.22-.032-.091-1.264.961-2.255s2.282-1.065,2.3-.843c.054.233-.879.619-1.729,1.446C261.119,456.286,260.686,457.2,260.456,457.132Z",
    fill: "#fff"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11986",
    "data-name": "Group 11986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11985",
    "data-name": "Group 11985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11984",
    "data-name": "Group 11984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11983",
    "data-name": "Group 11983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11982",
    "data-name": "Group 11982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11981",
    "data-name": "Group 11981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11980",
    "data-name": "Group 11980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11979",
    "data-name": "Group 11979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11978",
    "data-name": "Group 11978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11977",
    "data-name": "Group 11977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11976",
    "data-name": "Group 11976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11975",
    "data-name": "Group 11975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11974",
    "data-name": "Group 11974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11973",
    "data-name": "Group 11973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11972",
    "data-name": "Group 11972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11971",
    "data-name": "Group 11971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11970",
    "data-name": "Group 11970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11969",
    "data-name": "Group 11969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11968",
    "data-name": "Group 11968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6666",
    "data-name": "Path 6666",
    d: "M257.732,440.969c-.173.166-1.071-.544-2.361-.955-1.281-.437-2.425-.4-2.465-.639-.065-.211,1.214-.656,2.726-.151S257.91,440.838,257.732,440.969Z",
    fill: "#fff"
  })))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11989",
    "data-name": "Group 11989"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6667",
    "data-name": "Path 6667",
    d: "M282.325,296.428l-15.944,64.659s-28.752,48.4-33.619,72.619l26.3,10.345S278.191,397.4,283.8,388.84a68.458,68.458,0,0,1,8.662-10.667,16.73,16.73,0,0,0,4.364-7.564l12.07-46.132Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11993",
    "data-name": "Group 11993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11990",
    "data-name": "Group 11990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6668",
    "data-name": "Path 6668",
    d: "M275.534,286.1s2.217,17.311,18.882,24.987l35.121,57.2s2.758,18.6,8.057,34.274c5.26,15.559,15.856,45.864,15.856,45.864l28.889-10.8-18.412-62.944-3.012-21.83-28.664-72.952-24.619-14.763Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11992",
    "data-name": "Group 11992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11991",
    "data-name": "Group 11991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6669",
    "data-name": "Path 6669",
    d: "M275.534,286.1s.172-.126.527-.365l1.593-1.061,6.238-4.117,23.66-15.541.076-.05.079.047,24.639,14.728.054.032.023.059c8.021,20.37,17.811,45.232,28.719,72.931l.01.027,0,.029c.955,6.9,1.977,14.285,3.021,21.828l-.008-.036c4.978,17.008,10.3,35.191,15.785,53.935q1.324,4.527,2.634,9.007l.068.232-.226.085-28.89,10.793-.247.092-.085-.248c-5.011-14.51-9.835-28.479-14.412-41.735-1.149-3.309-2.28-6.586-3.22-9.869s-1.791-6.535-2.555-9.755q-2.274-9.663-3.7-18.831l.029.081C314.985,344.93,303.026,325.4,294.3,311.152l.058.051a32.764,32.764,0,0,1-11.034-8.384,34.686,34.686,0,0,1-5.393-8.655,35.152,35.152,0,0,1-2.006-5.96c-.17-.689-.261-1.219-.322-1.573s-.07-.536-.07-.536.036.177.106.53.175.878.356,1.562a36.758,36.758,0,0,0,2.065,5.92,34.879,34.879,0,0,0,5.421,8.577,32.653,32.653,0,0,0,10.99,8.276l.037.017.021.035,35.191,57.155.023.036.007.045c.961,6.08,2.2,12.363,3.718,18.789.766,3.212,1.611,6.46,2.56,9.729s2.07,6.534,3.224,9.847c4.586,13.251,9.418,27.215,14.439,41.72l-.332-.155,28.887-10.8-.158.316q-1.309-4.477-2.635-9.006l-15.768-53.94-.006-.018,0-.019c-1.039-7.544-2.055-14.932-3.005-21.83l.015.055-28.61-72.973.077.091-24.6-14.8.154,0-23.69,15.382-6.3,4.069-1.628,1.042C275.73,285.98,275.534,286.1,275.534,286.1Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11994",
    "data-name": "Group 11994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6670",
    "data-name": "Path 6670",
    d: "M290.957,162.52s-8.415,6.483-12.509,13.721c-4.9,8.665-5.428,21.523-5.582,41.477-.143,18.467,2.618,23.593,1.551,30.549-2.085,13.593-3.636,59.2-3.636,59.2s26.968-10.37,32.238-14.952l5.269-4.581,33.788,11.167-6.819-41.516-4.676-51.753-5.991-27.451-1.047-10.768L294.6,155.908Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11996",
    "data-name": "Group 11996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11995",
    "data-name": "Group 11995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6671",
    "data-name": "Path 6671",
    d: "M322.532,167.031c.353.065-.833,2.434-2.916,5.915l-.085.142-.159-.062c-2.935-1.136-6.812-2.568-11.052-4.114-4.782-1.743-9.1-3.361-12.191-4.623-1.546-.63-2.788-1.161-3.639-1.545a7.7,7.7,0,0,1-1.3-.649,7.77,7.77,0,0,1,1.376.461l3.7,1.39,12.237,4.477c4.241,1.547,8.109,3.024,11.021,4.233l-.243.08C321.44,169.3,322.729,167.052,322.532,167.031Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12009",
    "data-name": "Group 12009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11999",
    "data-name": "Group 11999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6672",
    "data-name": "Path 6672",
    d: "M357.446,145.435s-2.135-3.327-4.161-6.4-5.075-4.572-5.564-6.181-3.182-8.721-3.613-10.493a22.527,22.527,0,0,1-.516-5.219s2.207-.947,3.27,2.218c.639,1.9,2.675,8.351,3.114,8.667s1.048-.147,1.048-.147a75.087,75.087,0,0,1-2.356-7.375c-.1-1.17.312-8.925.312-8.925a2.343,2.343,0,0,1,2.659,1.487c1.049,1.974,1.088,7.01,1.088,7.01l1.588,5.583-.551-5.523.8-10.144a3.817,3.817,0,0,1,3.2,2.973c.672,2.743-.216,6.559.236,7.376s.935,5.712.935,5.712.549-11.906,1.817-12.248,2.317.925,2.135,3.327-.228,7.474.432,9.717,7.43,10.958,6.871,14.835a63.374,63.374,0,0,0-.621,6.98H357.923Z",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12000",
    "data-name": "Group 12000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6673",
    "data-name": "Path 6673",
    d: "M316.762,175.415c.65.245,28.362,7.1,28.362,7.1s6.191-10.036,7.094-12.9,5.759-22.217,5.759-22.217l11.712-1.107s-2.962,49.9-7.24,52.584-10.965,4.052-11.442,3.9-29.945,1.9-45.5-10.347S316.762,175.415,316.762,175.415Z",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12008",
    "data-name": "Group 12008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12001",
    "data-name": "Group 12001",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6674",
    "data-name": "Path 6674",
    d: "M296.9,201.822a21.2,21.2,0,0,0,11.331,6.663c7.354,1.62,23,4.481,23,4.481l-.764-7.677-34.046-3.644"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12005",
    "data-name": "Group 12005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12002",
    "data-name": "Group 12002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6675",
    "data-name": "Path 6675",
    d: "M284.561,191.262c2.521,5.322,8.115,11.018,20.429,12.289,24.366,2.516,42.817,3.86,50.788,2.658s11.14-18.066,11.962-18.586c2.478-1.567,2.324-6.924.184-8.523-6.082-4.545-18.276-8.04-19.1-7.631-4.844,2.409-3.265,8.048-3.265,8.048L314.7,172.7a52.193,52.193,0,0,0-11.074-3.227",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12004",
    "data-name": "Group 12004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12003",
    "data-name": "Group 12003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6676",
    "data-name": "Path 6676",
    d: "M303.63,169.476s.261.024.762.1,1.243.216,2.2.433a51.1,51.1,0,0,1,8.159,2.574l-.024-.008,30.878,6.722-.261.276a8.343,8.343,0,0,1,.4-5.33,5.879,5.879,0,0,1,1.75-2.2,7.711,7.711,0,0,1,1.2-.778,1.508,1.508,0,0,1,.458-.068l.366.038c.247.023.471.082.709.121a61.714,61.714,0,0,1,11.069,3.748,40.717,40.717,0,0,1,5.429,2.858c.438.282.861.591,1.294.887a3.827,3.827,0,0,1,1.064,1.274,7.065,7.065,0,0,1,.733,3.16,6.788,6.788,0,0,1-.72,3.2,3.843,3.843,0,0,1-1.134,1.283c-.121.06-.2.322-.3.563l-.263.752c-.661,2.046-1.314,4.139-2.118,6.194a27.894,27.894,0,0,1-4.543,8.164,9.044,9.044,0,0,1-3.752,2.71,9.15,9.15,0,0,1-2.258.434c-.747.106-1.493.125-2.235.191-2.969.172-5.883.13-8.733.053s-5.637-.223-8.353-.394c-10.863-.7-20.613-1.7-28.8-2.543a54.45,54.45,0,0,1-5.823-.837,31.166,31.166,0,0,1-5.028-1.524,22,22,0,0,1-7.09-4.459,18.914,18.914,0,0,1-3.277-4.167,11.6,11.6,0,0,1-.83-1.652c.033-.017.283.572.92,1.6a19.711,19.711,0,0,0,3.326,4.073,22.039,22.039,0,0,0,7.059,4.335,31.205,31.205,0,0,0,4.988,1.471,55.037,55.037,0,0,0,5.792.795c8.186.8,17.937,1.758,28.788,2.43,2.713.164,5.495.3,8.338.376s5.747.109,8.689-.066c.732-.066,1.475-.085,2.207-.19a8.7,8.7,0,0,0,2.145-.411,8.536,8.536,0,0,0,3.534-2.566,27.474,27.474,0,0,0,4.446-8.011c.8-2.038,1.445-4.109,2.111-6.169l.271-.773c.049-.13.1-.259.165-.394a1.645,1.645,0,0,1,.126-.218,1.226,1.226,0,0,1,.132-.137l.074-.058a3.327,3.327,0,0,0,.972-1.1,6.3,6.3,0,0,0,.659-2.951,6.57,6.57,0,0,0-.671-2.923,3.3,3.3,0,0,0-.916-1.1c-.423-.289-.835-.592-1.264-.869a40.352,40.352,0,0,0-5.357-2.829,61.652,61.652,0,0,0-10.959-3.739c-.224-.037-.455-.1-.673-.116l-.328-.036a1.525,1.525,0,0,0-.227.017,7.285,7.285,0,0,0-1.122.723,5.43,5.43,0,0,0-1.624,2.024,7.927,7.927,0,0,0-.388,5.017l.082.352-.342-.076-30.837-6.907-.012,0-.012-.006a54.527,54.527,0,0,0-8.088-2.677c-.953-.237-1.689-.394-2.185-.495S303.63,169.476,303.63,169.476Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12007",
    "data-name": "Group 12007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12006",
    "data-name": "Group 12006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6677",
    "data-name": "Path 6677",
    d: "M355.778,189.17a6.682,6.682,0,0,1-1.994-.867,20.245,20.245,0,0,1-4.208-3.142,20.8,20.8,0,0,1-3.278-4.1,6.828,6.828,0,0,1-.945-1.958,43.94,43.94,0,0,0,4.586,5.687A40.5,40.5,0,0,0,355.778,189.17Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12018",
    "data-name": "Group 12018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12013",
    "data-name": "Group 12013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12011",
    "data-name": "Group 12011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6678",
    "data-name": "Path 6678",
    d: "M138.223,271.526s6.194.336,10.038,2.741,10.006,6.137,12.552,10.774c1.169,2.128-2.163,2.578-3.808,1.342s-4.163-3.563-5.413-3.849l-1.25-.286a83.573,83.573,0,0,0,3.806,7.555c1.3,1.964,2.416,5.321-1.462,5.475,0,0-2.616,3.4-5.257.881,0,0-2.061,3.084-5.38-1.194,0,0-1.933,2.447-2.74,1.514s-3.449-2.423-4.221-5.479a108.361,108.361,0,0,0-4.015-10.49Z",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12012",
    "data-name": "Group 12012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6679",
    "data-name": "Path 6679",
    d: "M85.463,189.975a14.91,14.91,0,0,0-7.793,5.853c-2.383,3.661-3.109,10.047-2.431,14.724,1.441,9.943,6.006,26.741,8.567,37.519.885,3.724,2.7,10.377,8.028,13.914L129.719,284.7l10.13-15.036-34.542-28.149-6.826-38.582Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12015",
    "data-name": "Group 12015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12014",
    "data-name": "Group 12014"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6680",
    "data-name": "Path 6680",
    d: "M78.911,227.917a2.584,2.584,0,0,1,.123.395l.312,1.172c.271,1.058.659,2.578,1.157,4.528.992,3.965,2.42,9.674,4.189,16.749a19.6,19.6,0,0,0,6.237,9.882,38.21,38.21,0,0,0,5.538,3.682L102.561,268l27.292,16.483-.349.078c1.158-1.721,2.4-3.558,3.644-5.412,2.205-3.27,4.375-6.49,6.486-9.623l.051.344-34.239-28.187-.052-.043-.015-.065c-2.263-9.515-3.9-17.3-4.934-22.72-.52-2.708-.877-4.824-1.107-6.263-.1-.7-.183-1.247-.241-1.64-.051-.371-.062-.563-.062-.563s.051.186.121.553c.071.391.17.933.3,1.631.267,1.431.659,3.539,1.212,6.238,1.1,5.4,2.795,13.174,5.1,22.67l-.067-.107,34.312,28.1.182.149-.131.195c-2.111,3.133-4.28,6.354-6.483,9.625l-3.646,5.411-.138.2-.212-.128L102.318,268.4l-6.081-3.693a38.5,38.5,0,0,1-5.582-3.746,19.927,19.927,0,0,1-6.306-10.11l-4.034-16.792-1.066-4.55-.265-1.184A2.663,2.663,0,0,1,78.911,227.917Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12017",
    "data-name": "Group 12017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12016",
    "data-name": "Group 12016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6681",
    "data-name": "Path 6681",
    d: "M79.534,195.328A2.361,2.361,0,0,1,80.3,195a13.27,13.27,0,0,1,2.215-.5,13.076,13.076,0,0,1,7.391,1,14.691,14.691,0,0,1,5.522,5.03,9,9,0,0,1,1.008,2.042,2.133,2.133,0,0,1,.176.818,20.237,20.237,0,0,0-1.489-2.655,15.7,15.7,0,0,0-5.447-4.768,13.739,13.739,0,0,0-7.118-1.1C80.686,195.049,79.559,195.417,79.534,195.328Z",
    fill: "#263238"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetpasswordHero);
export default __webpack_public_path__ + "static/media/resetpasswordHero.4b404b9881a7a7ab57cf62c6fa8625bc.svg";
export { ForwardRef as ReactComponent };